<template>
	<div>
		<AgencyBanner />
		<div class="content-zsy">
			<div v-if="show">
			
				<div class="config-title-wrap">
					<div>
						<h3>상품 정보 입력</h3>
						<p>
							<strong>배송대행 상품 정보 입력</strong><br>
							주문한 상품의 관련정보를 정확하게 입력해 주세요.<br>
							<!-- 상품의 이미지를 등록해 주시면 보다 정확한 상세검수진행이 가능합니다.     -->                               
						</p>
					</div>
					<div class="get-order" v-if="!isMobile">
						<div class="top">
							<ul>
								<li>1688<img src="../../assets/icon/shipping-auto-img1.png" alt="1688" loading="lazy"></li>
								<li>타오바오<img src="../../assets/icon/shipping-auto-img2.png" alt="타오바오" loading="lazy"></li>
							</ul>
							<a @click="onOrderlayer" class="event-common-click-dialog">구매목록<br>가져오기</a>
						</div>
						<!-- <a href="/xlsUpload" target="_blank" class="link-excel">
							<img src="../../assets/icon/shipping-excel.png" alt="엑셀대량등록" loading="lazy">엑셀대량등록
						</a> -->
					</div>
					
					
					
				</div>
				
				<!-- 배송방법 및 통관방법 정보 표시 显示配送方式及通关方式信息-->
				<div style="background-color: #f5f7fa; border: 1px solid #ebeef5; padding: 15px 20px; border-radius: 10px; margin-bottom: 20px; display: flex; gap: 40px; font-size: 15px;">
					<div>
						<strong style="color: #606266;">배송방법 (배송지):</strong>
						<span style="margin-left: 10px; font-weight: bold; color: #303133;">
							{{ deliveryCenterCode === 'CN_AIR' ? '항공' : (deliveryCenterCode === 'CN_SHIP' ? '해상' : (deliveryCenterCode === 'CN_LCL' ? '화물' : deliveryCenterCode)) }}
						</span>
					</div>
					<div>
						<strong style="color: #606266;">통관방법:</strong>
						<span style="margin-left: 10px; font-weight: bold; color: #303133;">
							{{ customsTypeName || '-' }}
						</span>
					</div>
				</div>

				<div style="position: -webkit-sticky; position: sticky; top: 120px; z-index: 999; display: flex; justify-content: flex-end; margin-bottom: 20px; background-color: #fff; padding: 10px 0;">
					<el-button
						type="primary" 
						icon="el-icon-plus" 
						@click="addItem"
					>
						상품추가
					</el-button>
				</div>
			<el-form
				ref="dynamicForm" 
				:model="formData" 
				:label-width="isMobile?'110px':'130px'"
			>
					<!-- 动态表单项列表 -->
				<div 
					v-for="(item, index) in formData.items" 
					:key="item.id" >
			<!-- 使用虚拟滚动列表 -->
<!-- 			<RecycleScroller
				:class="!isMobile?'scroller':''" 
				:items="formData.items"
				:item-size="!isMobile?400:960"
				key-field="id" 
			>
				
				<template v-slot="{ item, index }">
					<div> -->
						<div style="padding:10px 0 20px 30px;">
							<el-button
								type="primary" plain		disabled		
							>
								{{index+1}}
							</el-button>
						
							<!-- 删除按钮 -->
							<el-button 
								type="danger" 
								icon="el-icon-delete" 
								@click="removeItem(index)"
								:disabled="formData.items.length <= 1"
							>
								삭제
							</el-button>
						</div>

					<el-row>
						<el-col :xs="24" :sm="8">
							<el-form-item >
								<div class="flex" style="align-items:center;">
									<el-button type="primary" @click="onUpload(index)" size="small">이미지 등록</el-button>
									<a target="_blank" :href="formatImgUrl(item.imageUrl)" v-if="item.imageUrl">
										<el-image 
											style="width:140px;height:140px;border-radius: 10px; margin-left: 10px;"
											:src="formatImgUrl(item.imageUrl)" referrerpolicy="no-referrer"
											fit="cover"></el-image>
									</a>
									<div v-else style="width:140px;height:140px;border-radius: 10px; margin-left: 10px; background-color: #f5f7fa; border: 1px solid #ebeef5; display: flex; align-items: center; justify-content: center;">
										<i class="el-icon-picture-outline" style="font-size: 30px; color: #909399;"></i>
									</div>
								</div>
							</el-form-item>
						</el-col>

						<el-col :xs="24" :sm="8">
							<el-form-item
							  :label="'품목분류'"
							  :prop="`items.${index}.category_name`"
							  :rules="[
								{ required: true, message: '품목분류 필수', trigger: 'change' },
							  ]"
							>
								<div class="flex">
									<el-popover
										placement="bottom"
										width="700"
										trigger="click"
										v-model="item.showPopover"
										@show="onCategoryDialog(index)"
										popper-class="category-popper"
										style="flex: 1;"
									>
										<div class="category-dropdown-content">
											<div class="scroller-container">
												<div class="v-table-header">
													<div class="v-col-l1">1차 분류</div>
													<div class="v-col-l2">2차 분류 (HS Code)</div>
													<div class="v-col-l3">3차 분류 (상세)</div>
												</div>
												
												<RecycleScroller
													class="category-v-scroller"
													:items="item.showPopover ? filteredCategories : []"
													:item-size="65"
													key-field="uniqueId"
													v-slot="{ item: catItem }"
												>
													<div class="v-category-row" @click="handleSelectCategory(catItem)" style="cursor: pointer;">
														<div class="v-col-l1">
															<div class="ko" v-html="highlightCategoryText(catItem.l1)"></div>
														</div>
														<div class="v-col-l2">
															<div class="ko">
																<span v-html="highlightCategoryText(catItem.l2)"></span>
																<span class="code">({{' '}}<span v-html="highlightCategoryText(catItem.l2_code)"></span>{{' '}})</span>
															</div>
															<div class="cn" v-if="catItem.l2_cn" v-html="highlightCategoryText(catItem.l2_cn)"></div>
														</div>
														<div class="v-col-l3">
															<div class="ko" v-html="highlightCategoryText(catItem.l3)"></div>
															<div class="code" v-if="catItem.l3_code !== '-'" v-html="highlightCategoryText(catItem.l3_code)"></div>
														</div>
													</div>
												</RecycleScroller>
											</div>
										</div>
										<el-input 
											slot="reference" 
											v-model="item.category_name" 
											placeholder="분류를 입력하거나 선택하세요" 
											@input="onSearchInput(index)"
										></el-input>
									</el-popover>
									<el-popover
										placement="top"
										width="300"
										trigger="hover"
										>
										<div>
											원하시는 품목분류가 없으신가요?<br>추가희망 하시는 품목분류를 고객센터로<br>알려주시면 즉시 추가하여드립니다
										</div>
										<i class="el-icon-question icon-question"  slot="reference"></i>
									</el-popover>
								</div>
								
							</el-form-item>
						</el-col>
						<el-col :xs="24" :sm="8">
							<!-- 商品名称（英文） -->
							<el-form-item 
							  :label="'상품명(영문)'"
							  :prop="`items.${index}.goods_name`"
							  :rules="[
								{ required: true, message: '상품명 필수', trigger: 'blur' },
								//{ min: 2, max: 10, message: '姓名长度在 2-10 个字符之间', trigger: 'blur' }
							  ]"
							>
								<div class="flex">
									<el-input v-model="item.goods_name"  clearable ></el-input>
									<el-popover placement="top" width="300" trigger="hover" >
										<div>
											검색( HS코드네비게이션)에서 보다 정확한 결과를 얻을수 있습니다
										</div>
										<i class="el-icon-question icon-question"  slot="reference"></i>
									</el-popover>
								</div>
	  
							</el-form-item>
						</el-col>
						<el-col :xs="24" :sm="8">
							<!-- 追踪号码 快递单号 -->
							<el-form-item 
							  :label="'트래킹넘버'"
							  :prop="`items.${index}.tracking_no`"
							>
								<div class="flex">
									<el-input v-model="item.tracking_no" placeholder="여러개 입력시 ,(콤마)" clearable ></el-input>
									<el-popover placement="top" width="300" trigger="hover" >
										<div>
											판매자 상품발송후 제공된 트래킹번호를 즉시 입력해주세요<br>입력이 안될경우 노데이터로 분류되어서 입고가 지연됩니다.
										</div>
										<i class="el-icon-question icon-question"  slot="reference"></i>
									</el-popover>
								</div>
							  
							</el-form-item>
						</el-col>
						<el-col :xs="24" :sm="8">
							<!-- 尺寸（中文）size -->
							<el-form-item 
							  :label="'사이즈(중국어)'"
							  :prop="`items.${index}.size`"
							>
								<div class="flex">
									<el-input v-model="item.size"  clearable ></el-input>
								</div>
							</el-form-item>
						</el-col>
						<el-col :xs="24" :sm="8">
							<!-- 订单号 -->
							<el-form-item 
							  :label="'주문번호'"
							  :prop="`items.${index}.order_no`"
							>
								<div class="flex">
									<el-input v-model="item.order_no"  clearable ></el-input>
									<el-popover placement="top" width="300" trigger="hover" >
										<div>
											구매 주문번호를 입력해주세요.
										</div>
										<i class="el-icon-question icon-question"  slot="reference"></i>
									</el-popover>
								</div>
							</el-form-item>
						</el-col>
						<el-col :xs="24" :sm="8">
							<!-- 颜色（中文） -->
							<el-form-item 
							  :label="'색상(중국어)'"
							  :prop="`items.${index}.color`"
							>
								<div class="flex">
									<el-input v-model="item.color"  clearable ></el-input>
								</div>
							</el-form-item>
						</el-col>
						<el-col :xs="24" :sm="8">
							<!-- 单价 -->
							<el-form-item 
							  :label="'단가'"
							  :prop="`items.${index}.price`"
							  :rules="[
								{ required: true, message: '단가 필수', trigger: 'blur' },
							  ]"
							>
								<div class="flex">
									<el-input v-model="item.price" clearable @input="item.price = item.price.match(/^\d*(\.?\d{0,2})/g)[0] || ''"></el-input>
									<div style="padding-left: 5px;" >CNY</div>
								</div> 
							</el-form-item>
						</el-col>
						<el-col :xs="24" :sm="8">
							<!-- 管理编号 -->
							<el-form-item 
							  :label="'관리코드'"
							  :prop="`items.${index}.product_code`"
							>
								<div class="flex">
									<el-input v-model="item.product_code"  clearable ></el-input>
									<el-popover placement="top" width="300" trigger="hover" >
										<div>
											관리코드를 부여해서 관리해보세요
										</div>
										<i class="el-icon-question icon-question"  slot="reference"></i>
									</el-popover>
								</div>
							</el-form-item>
						</el-col>
						<el-col :xs="24" :sm="8">
							<!-- 包装盒数量 -->
							<el-form-item 
							  :label="'포장박스수량'"
							  :prop="`items.${index}.box_count`"
							>
								<div class="flex">
									<el-input v-model="item.box_count" clearable @input="item.box_count = item.box_count.replace(/[^\d]/g, '')" style="width: 100%;"></el-input>
									<el-popover placement="top" width="300" trigger="hover" >
										<div>
											판매자가 발송한 총 박스수량 을 입력해주세요
										</div>
										<i class="el-icon-question icon-question"  slot="reference"></i>
									</el-popover>
								</div>
							</el-form-item>
						</el-col>
						<el-col :xs="24" :sm="8">
							<!-- 数量 -->
							<el-form-item 
							  :label="'수량'"
							  :prop="`items.${index}.apply_quantity`"
							  :rules="[
								{ required: true, message: '수량 필수', trigger: 'blur' },
							  ]"
							>
								<div class="flex">
									<el-input-number v-model="item.apply_quantity" :min="1" :precision="0" :controls="false" class="num-input-left" style="width: 100%;"></el-input-number>
									<div style="padding-left: 5px;" >개</div>
								</div> 
							</el-form-item>
						</el-col>
						<el-col :xs="24" :sm="8">
							<!-- 商品代码 -->
							<el-form-item 
							  :label="'상품코드'"
							  :prop="`items.${index}.refer_code`"
							>
								<div class="flex">
									<el-input v-model="item.refer_code"  clearable ></el-input>
									<el-popover placement="top" width="300" trigger="hover" >
										<div>
											국내마켓 상품관리에 필요한 상품코드를 입력 관리해보세요
										</div>
										<i class="el-icon-question icon-question"  slot="reference"></i>
									</el-popover>
								</div>
							</el-form-item>
						</el-col>
						<el-col :xs="24" :sm="8">
							<!-- 商品url -->
							<el-form-item 
							  :label="'상품 URL'"
							  :prop="`items.${index}.url`"
							  :rules="[
							  		{ required: true, message: '상품 URL 필수', trigger: 'blur' },
							  ]"
							>
								<div class="flex">
									<el-input v-model="item.url"  clearable ></el-input>
								</div>
							</el-form-item>
						</el-col>
						<el-col :xs="24" :sm="8">
							<!-- 发货备注 -->
							<el-form-item 
							  :label="'요청메세지'"
							  :prop="`items.${index}.shipping_memo`"
							>
								<div class="flex">
									<el-input v-model="item.shipping_memo" placeholder="로켓크로스 요청사항, 원산지증명서 C/O 옵션 선택 시, HS코드를 입력해 주세요." clearable ></el-input>
								</div>
							</el-form-item>
						</el-col>
					
						<!-- <el-col :xs="24" :sm="12" v-if="deliveryCenterCode != 'CN_LCL'">
						<div style="margin: 0 0 20px 20px;">
							
							<el-checkbox v-model="item.origin">원산지작업(유료)</el-checkbox>
							
							<el-checkbox v-model="item.package">포장보완(유료)</el-checkbox>
							
							<el-checkbox v-model="item.check">정밀검수(유료)</el-checkbox>
						</div>
						
						</el-col> -->

						<!--부가서비스 신청 버튼 - 单独一行-->
						<el-col :xs="24" :sm="24">
							<div style="margin: 0 0 20px 20px; display: flex; align-items: center; flex-wrap: wrap;">
								<el-button type="primary" size="mini" plain icon="el-icon-setting" @click="openExtraServicesDialog(index)">
									부가서비스 신청
								</el-button>
								<div v-if="hasSelectedExtraServices(item)" style="margin-left: 15px; font-size: 12px; color: #666; line-height: 1.6;">
									<strong style="color: #ff5700;font-size:15px;">신청한 부가 서비스: </strong>
									<span style="font-weight: 500; color: #333;">{{ formatSelectedExtraServices(item) }}</span>
								</div>
							</div>
						</el-col>
						
					
					</el-row>


					
					
					
				  <!-- </div>
				</template>
			</RecycleScroller> -->
			</div>  
				  
				  <!-- 商品分类弹框 已改为下拉 Popover -->
				  <!--上传图像-->
				  <el-dialog
				    title="이미지 등록" :width="isMobile?'90%':'30%'"
				    :visible.sync="uploadVisible" center>
				      <el-radio-group v-model="upload" size="mini" @change="changeUpload">
				        <el-radio :label="1" style="margin-bottom: 10px;">이미지 직접 업로드</el-radio>
				        <el-radio :label="2" style="margin-bottom: 10px;">이미지 URL 등록</el-radio>
				      </el-radio-group>
					  <div v-if="upload==1">
						<el-upload
						  class="avatar-uploader"
						  :action="update_url+'/common/upload'"
						  :show-file-list="false"
						  :on-success="handleAvatarSuccess"
						  :before-upload="beforeAvatarUpload">
							<el-image v-if="imageUrl"
								class="avatar"
								:src="imageUrl"
								fit="cover"></el-image>
							<el-button size="small" plain type="primary">업로드 클릭</el-button>
						</el-upload>
					  </div>
					  <div v-else>
						<el-input v-model="imageUrl" placeholder="URL은 http포함해서 입력해 주세요."></el-input>
					  </div>
				    <span slot="footer" class="dialog-footer">
				      <el-button type="primary" @click="submitUpload">등록하기</el-button>
				    </span>
				  </el-dialog>
				  <!-- 不可空运商品指南 弹框 -->
				  <el-dialog title="" :visible.sync="AirVisible" :width="isMobile?'96%':'50%'" :close-on-click-modal="false" :close-on-press-escape="false" >
				  	<div class="air-popup-content">
				  		<h2>항공선적 불가상품 안내</h2>
				  		<el-row>
				  			<el-col :xs="24" :sm="12" style="padding:0 5px;">
				  				<div class="category-title">01. 전자제품류</div>
				  				<ul class="dot-list">
				  					<li>● 휴대폰</li>
				  					<li>● 태블릿 PC</li>
				  					<li>● 전자담배</li>
				  					<li>● 단독 및 보조배터리, 배터리가 포함된 제품들</li>
				  					<li>● 이어폰</li>
				  					<li>● 시계류</li>
				  					<li>● 각종 배터리(건전지 등)가 포함된 제품</li>
				  					<li>● 모터</li>
				  					<li>● 블루투스 기능이 있는 제품</li>
				  					<li>● 전선류, 콘센트 등 기타 모든 전자제품류</li>
				  				</ul>
				  			</el-col>
				  			<el-col :xs="24" :sm="12" style="padding:0 5px;">
				  				<div class="category-title">02. 액체류</div>
				  				<ul class="dot-list">
				  					<li>● 화장품</li>
				  					<li>● 방향제</li>
				  					<li>● 인화성 액체(휘발유, 석유, 라이터 연료, 페인트 등)</li>
				  					<li>● 아세톤 등 화기물품</li>
				  					<li>● 기타 모든 액체류</li>
				  				</ul>
				  			</el-col>
				  			<el-col :xs="24" :sm="12" style="padding:0 5px;">
				  				<div class="category-title">03. 장난감류</div>
				  				<ul class="dot-list">
				  					<li>● 장난감 총</li>
				  					<li>● 검</li>
				  					<li>● 활</li>
				  					<li>● 무기류(플라스틱 재질 포함)</li>
				  				</ul>
				  			</el-col>
				  			<el-col :xs="24" :sm="12" style="padding:0 5px;">
				  				<div class="category-title">04. 화학류</div>
				  				<ul class="dot-list">
				  					<li>● 방사성 물질</li>
				  					<li>● 가연성 물질(성냥, 촛 등)</li>
				  					<li>● 화약, 폭약류</li>
				  					<li>● 폭발물류</li>
				  					<li>● 독극물류(살충제, 농약 등)</li>
				  					<li>● 인화물</li>
				  					<li>● 생활화학 물질</li>
				  					<li>● 고압가스 포함 제품류(스프레이, 부탄가스, 소화기 등)</li>
				  				</ul>
				  			</el-col>
				  			<el-col :xs="24" :sm="12" style="padding:0 5px;">
				  				<div class="category-title">05. 기타</div>
				  				<ul class="dot-list">
				  					<li>● 동, 식물</li>
				  					<li>● 자동차 부품</li>
				  					<li>● 식품류</li>
				  					<li>● 건강보조제</li>
				  					<li>● 분말류</li>
				  					<li>● 자석류</li>
				  					<li>● 세변의 합 140cm 이상 혹은 한 변의 길이 100cm 이상 상품</li>
				  					<li>● 구성품에 포함된 본드/액체 등 모든 항공선적불가품</li>
				  				</ul>
				  			</el-col>
				  		</el-row>
				  		<strong>
				  		    위 상품들은 항공선적이 절대 불가하오니 반드시 참고하시어 신청서 작성 바랍니다.
				  		</strong>
				  		<div style="text-align: center;">
				  			<div class="link-btn type-2" @click="onCurrentNav('')">
				  				항공선적불가 바로가기 <i class="el-icon-top-right"></i>
				  			</div>
				  		</div>
				  		<p class="popup-desc text-center">항공선적불가상품으로 신청 시 선적불가상품으로 인해(상품류 또는 패키지/출고 규격) 등이 발생할 수 있으며<br>
				  		   상품의 고로켓고 중국물류센터 리턴 시 착불 비용이 청구되며, 기타 추가 비용이 청구될 수 있습니다.<br>
				  			구매상품 총$2.000(달러) 이상 항공으로 진행시, 세관 창고료가 발생 될수 있음을 안내 드립니다<br><br>
				  			기타 문의사항은 고객센터로 부탁드리겠습니다.
				  		</p>
				  	</div>
				  </el-dialog>
				  
				  
				  <!--当地税金--><!--当地运费--><!--折扣金额-->
				  <!-- <div class="customs-real-price">
					  
					  <div class="box">
						  <div class="title">현지 세금</div>
						  <div class="input-group">
							  <el-input v-model="sales_tax"></el-input>
							  <div class="input-group-addon">CNY</div>
						  </div>
					  </div>
					  
					  <div class="box">
						  <div class="title">현지 배송비</div>
						  <div class="input-group">
							  <el-input v-model="shipping"></el-input>
							  <div class="input-group-addon">CNY</div>
						  </div>
					  </div>
					  
					  <div class="box">
						  <div class="title">할인 금액</div>
						  <div class="input-group">
							  <el-input v-model="discount"></el-input>
							  <div class="input-group-addon">CNY</div>
						  </div>
					  </div>
					  <div class="box total">
						  <div class="title">상품 단가 반영</div>
						  <div style="text-align: center;padding-top: 10px;">
							  <el-button type="primary" @click="calcAmount">반영하기</el-button>
						  </div>
					  </div>
					  <p class="explain">
						* 구매비용은 세관에 신고되는 상품가격이기 때문에 <span class="color-blue">고객님께서 결제하신 금액과 일치</span> 해야 합니다.<br>
						* 현지 세금, 현지 배송비, 할인 금액을 입력하는 경우 <span class="color-blue">단가에 반영하기 버튼을 눌러야 적용되므로,</span> 상품 정보를 모두 입력 후 반영하기를 눌러주세요.
					  </p> 
				  </div> -->
				  
				  <div class="customs-after-box" v-if="!isMobile">
					<div class="customs">
						<strong>
						{{customsTypeName}}으로 진행됩니다.
						</strong>
						<a href="/bizCustomsInfo" target="_blank" class="btn btn-submit">{{customsTypeName}}</a>
					</div>						  
				 
					<div class="after">
						  <div class="total-price">
							  총 상품금액 :
							  <span id="customs-real-price">¥{{totalAmount.toFixed(2)}}</span>
						  </div>
					</div> 
				  </div>
				  <div class="customs-after-box" v-else>
					  <div class="customs">
						  <strong>
							  {{customsTypeName}}으로 진행됩니다.
						  </strong>
							<a href="/bizCustomsInfo" target="_blank" class="btn btn-submit">{{customsTypeName}}</a>
					  </div>
					  <div class="after">
						  <div class="total-price">
							  총 상품금액 :
							  <span id="customs-real-price">¥{{totalAmount.toFixed(2)}}</span>
						  </div>
					  </div>
				  </div>
				  
				  <div class="type-card shadow-all">
					<div class="card-head">
					    부가서비스 신청 내역
					</div>
					<div class="card-body">
						<div class="card-help">
							부가서비스 상세내역을 꼭! 확인하세요.
							<a href="/bizAddService" class="type-1 link-btn" style="width: 100px;" target="_blank">
							바로가기<i class="el-icon-top-right"></i>
							</a>
						</div>
						<el-row class="col-wrap">
							<el-col :xs="24" :sm="8">
								<div class="group">
									<h4>제거</h4>
									<el-checkbox-group v-model="formData.data.remove" @change="onCheck" >
										
										<label class="checkbox-inline" v-for="(item,index) in agency_attach.remove" :key="index" > 
										<!-- formData.data.remove1  <input name="od_serviceOption[]" type="checkbox" class="type-checkbox" value="remove1"> 신발박스 제거 -->   
											<el-checkbox :label="item.id" >{{item.name}}  
												<el-popover
														placement="top"
														width="420"
														trigger="hover"
														>
														<div style="padding:10px 20px;" v-html="item.remarks"></div>
														<i class="el-icon-question icon-question"  slot="reference"></i>
												</el-popover>
											</el-checkbox>
											<span>{{item.subtitle}}</span>
										</label>
									</el-checkbox-group>
								</div>
								<div class="group">
									<h4>검수</h4>							
									<el-radio-group v-model="formData.data.check_level" style="width: 100%;" >
										<label class="checkbox-inline" v-for="(item,index) in agency_attach.check_level" :key="index">
											<el-radio :label="item.id" >{{item.name}}
												<el-popover
														placement="top"
														width="400"
														trigger="hover"
														>
														<div style="padding:10px 20px;" v-html="item.remarks"></div>
														<i class="el-icon-question icon-question"  slot="reference"></i>
												</el-popover>
											</el-radio>
											<span>{{item.subtitle}}</span>
										</label>
									</el-radio-group>

								</div>
								
							</el-col>
							<el-col :xs="24" :sm="8" >
								<div class="group">
									<h4>포장</h4>
									<el-radio-group v-model="formData.data.packing_level" style="width: 100%;" >
										<label class="checkbox-inline" v-for="(item,index) in agency_attach.packing_level" :key="index">
											<el-radio :label="item.id" >{{item.name}}
												<el-popover
														placement="top"
														width="400"
														trigger="hover"
														>
														<div style="padding:10px 20px;" v-html="item.remarks"></div>
														<i class="el-icon-question icon-question"  slot="reference"></i>
												</el-popover>
											</el-radio>
											<span>{{item.subtitle}}</span>
										</label>		
									</el-radio-group>
									<el-checkbox-group v-model="formData.data.add_packing" >
										<label class="checkbox-inline" v-for="(item,index) in agency_attach.add_packing" :key="index">
											<el-checkbox :label="item.id" >{{item.name}}
												<el-popover
														placement="top"
														width="400"
														trigger="hover"
														>
														<div style="padding:10px 20px;" v-html="item.remarks"></div>
														<i class="el-icon-question icon-question"  slot="reference"></i>
												</el-popover>
											</el-checkbox>
											<span>{{item.subtitle}}</span>
										</label>			
									</el-checkbox-group>
								</div>
							</el-col>
							<el-col :xs="24" :sm="8" >
								<div class="group">
									<h4>기타</h4>
									<el-checkbox-group v-model="formData.data.template" >
										<div style="display: flex;align-items: center;" v-for="(item,index) in agency_attach.template" :key="index" >
											<label class="checkbox-inline checkbox-inline-margin" style="width:80%;">
												<el-checkbox :label="item.id" >{{item.name}}
													<el-popover
															placement="top"
															width="400"
															trigger="hover"
															>
															<div style="padding:10px 20px;" v-html="item.remarks"></div>
															<i class="el-icon-question icon-question"  slot="reference"></i>
													</el-popover>
												</el-checkbox>
												<span>{{item.subtitle}}</span>
											</label>
											<el-input v-model="formData.data[`template${item.id}_cnt`]" style="width:20%;margin-top: 10px;">
												<template slot="suffix">개</template>
											</el-input>
										</div>

									</el-checkbox-group>
									<el-checkbox-group v-model="formData.data.customs" >
										<label class="checkbox-inline" style="width: 100%;" v-for="(item,index) in agency_attach.customs" :key="index">
											<el-checkbox :label="item.id" >{{item.name}}
												<el-popover
														placement="top"
														width="400"
														trigger="hover"
														>
														<div style="padding:10px 20px;" v-html="item.remarks"></div>
														<i class="el-icon-question icon-question"  slot="reference"></i>
												</el-popover>
											</el-checkbox>
											<span>{{item.subtitle}}</span>
										</label>				
									</el-checkbox-group>
								</div>
							</el-col>
						</el-row>
						
						<div class="card-help text-center bottom">
							아이템별 정밀검수, 포장보완, 원산지 작업은 상단 신청서 입력란에서 선택해주세요.
						</div>
						
					</div>  
				  </div>
				  
				  <div class="type-card shadow-all">
					<div class="card-head">
						배송지 정보 입력
					</div>
					<div class="card-body">
						<div class="card-help">
							상품을 받으실 수취인 정보를 입력해 주세요.
							<p class="normal" style="margin-bottom: 10px;">
							(수입신고자 명의로 통관을 진행하기 때문에 본인외에 수취인 정보를 입력할 경우, 세관에서 관계증명서 및 사유서 제출을 요구할 수 있습니다.)
							</p>
							외국인의 경우 <span class="color-red">[한글수취인명]</span> 입력란에도 <span class="color-red">여권상의 영문 이름</span>을 입력해주세요.<br>
							<!-- Đối với người nước ngoài, vui lòng nhập tên tiếng Anh trên hộ chiếu vào ô nhập <span class="color-red">[한글수취인명]</span>                     -->
						</div>
						
						<el-button type="primary" @click="openAddress" round>배송지 주소록</el-button>
						
						<div style="margin:30px 0;">
							<el-descriptions title="" direction="vertical" :column="4" border>
								  <el-descriptions-item label="수취인명">{{address_info.consignee}}</el-descriptions-item>
								  <el-descriptions-item label="연락처">{{address_info.mobile}}</el-descriptions-item>
								  <el-descriptions-item label="	개인통관고유부호" >{{address_info.customs_info}}</el-descriptions-item>
								  <el-descriptions-item label="우편번호">{{address_info.zipcode}}</el-descriptions-item>
								  <el-descriptions-item label="주소">{{address_info.address}} {{address_info.detailed_address}}</el-descriptions-item>
							</el-descriptions>
						</div>
						<el-row>
							<el-col :xs="24" :sm="4" class="background-color">국내 택배사 요청사항</el-col>
							<el-col :xs="24" :sm="20">
								<el-input v-model="formData.data.express_demand" maxlength="30" placeholder="30자 이내로만 입력할 수 있습니다."></el-input>
							</el-col>							
						</el-row>
					
						

					</div>
				  </div>
				  
				  <div class="type-card shadow-all">
						<div class="card-head">
							세부 정보 설정
						</div>
						<div class="card-body">
							<el-row class="col-wrap">
								<el-col :xs="24" :sm="5">
									<div class="group">
										<h4>결제 옵션</h4>
										<el-checkbox-group v-model="formData.data.pay_service">
											<label class="checkbox-inline">
												<el-checkbox label="1" > 자동배송 요청</el-checkbox>
											</label>
											<label class="checkbox-inline">
												<el-checkbox label="2" > 로켓머니</el-checkbox>
											</label>
										</el-checkbox-group>
									</div>
								</el-col>
								<el-col :xs="24" :sm="9">
									<div class="group">
										<h4>선/착불 구분
											<el-popover
													placement="top"
													width="410"
													trigger="hover"
													>
													<ul class="dot-list">
														<li style="font-size: 13px;font-weight: 400;" >● [경동착불]: 경동 인계 사이즈가 아닐 경우<br>국내 일반 택배사로 정상 인계되는 점 안내드리겠습니다.</li>
														<li style="font-size: 13px;font-weight: 400;">● [경동선불]: 통관 후, 경동 택배 선불로 발송됩니다.<br>(주의: 경동 인계 사이즈 미달이나 선택할 경우 경동 비용발생.)</li>
														<li style="font-size: 13px;font-weight: 400;">● [화물차]: 통관 후, 화물차로 단독 발송됩니다.</li>
														<li style="font-size: 13px;font-weight: 400;">● ※ 경동/화물 인계의 경우 별도의 국내 배송 비용이 발생됩니다.</li>
													</ul>
													<i class="el-icon-question icon-question"  slot="reference"></i>
											</el-popover>
										</h4>
										<el-radio-group v-model="formData.data.service_cargo_type" @input="onCargoType" style="display: flex;" >
											<label class="checkbox-inline">
												<el-radio label='1' >경동 선불</el-radio>
											</label>
											<label class="checkbox-inline">
												<el-radio label='2' >경동 착불</el-radio>
											</label>
											<label class="checkbox-inline">
												<el-radio label='3' >화물차</el-radio>
											</label>
										</el-radio-group>
										
									</div>	
								</el-col>
								<el-col :xs="24" :sm="5">
									<div class="group">
										<h4>FTA 세율 적용 여부
											<el-popover
													placement="top"
													width="400"
													trigger="hover"
													>
													<ul class="dot-list">
														<li style="font-size: 13px;font-weight: 400;" >● 한중 FTA 협정 세율 적용 $700 이하 수입 시 원산지증명서를 제출해 주셔야합니다.<br>[부가서비스-기타-원산지 증명서 C/O 옵션 선택바랍니다.]</li>
														<li style="font-size: 13px;font-weight: 400;"><a href="" target="_blank">[주의사항 바로가기]</a></li>
													</ul>
													<i class="el-icon-question icon-question"  slot="reference"></i>
											</el-popover>
										</h4>
										<el-radio-group v-model="formData.data.service_fta_type" style="display: flex;" >
											<label class="checkbox-inline">
												<el-radio label='1' >적용</el-radio>
											</label>
											<label class="checkbox-inline">
												<el-radio label='2' >미적용</el-radio>
											</label>
									
										</el-radio-group>
									</div>
									
								</el-col>
								<el-col :xs="24" :sm="5">
									<div class="group">
										<h4>관부가세 안내</h4>
										<el-radio-group v-model="formData.data.service_tariff_notify" style="display: flex;" >
											<label class="checkbox-inline">
												<el-radio label='1' >송하인</el-radio>
											</label>
											<label class="checkbox-inline">
												<el-radio label='2' >수령인</el-radio>
											</label>									
										</el-radio-group>
									</div>
									<!-- <div class="group">
										<h4>사업자 출고 알림톡
											<el-popover
													placement="top"
													width="400"
													trigger="hover"
													>
													<ul class="dot-list">
														<li style="font-size: 13px;font-weight: 400;" >● 출고알림톡을 적용 신청하시면 수령인에게 배송출발시 알림톡이 발송됩니다</li>
														<li style="font-size: 13px;font-weight: 400;" >● 알림톡은 고로켓고 채널로 발송되며, 알림내용 상단에 회원님 쇼핑몰 이름이 표기됩니다</li>
														<li style="font-size: 13px;font-weight: 400;"><a href="" target="_blank">[보러가기]</a></li>
													</ul>
													<i class="el-icon-question icon-question"  slot="reference"></i>
											</el-popover>
										</h4>
										<el-radio-group v-model="formData.data.service_delivery_notify" style="display: flex;" >
											<label class="checkbox-inline">
												<el-radio :label="1" >발송</el-radio>
											</label>
											<label class="checkbox-inline">
												<el-radio :label="2" >미발송</el-radio>
											</label>									
										</el-radio-group>
									</div> -->
								</el-col>
							</el-row>
							
						</div>
					</div>
					
					<div class="caution-box">
							<div>● 1개의 배송신청서 상 서로 다른 트래킹 번호 5 (가지)까지 무료<br>
								1개의 배송신청서 상 서로 다른 트래킹 번호 5 (가지) 초과 시, 추가된 트래킹번호 1가지 당 500원 청구</div>
							<div>● 항공선적 불가상품을 항공배송으로 신청 시 선적불가상품으로 인해 (상품압류 또는 폐기/출고불가)등이 발생할 수 있으며<br>
								상품이 고로켓고 중국물류센터로 리턴 시 착불 비용이 청구되며, 기타 추가 비용이 청구될 수 있습니다.</div>
							<div>● 국내 택배사 집하 거부로 유리제품, 도자기 류, 모니터 류, 가구 류는 국내 배송 파손 시 택배사 면책을 동의해야 출고 가능합니다.</div>
							<div>● 합포장·합배송 상품의 원포장자재가 부실할 경우 포장자재 신청해주셔야 합니다.</div>
							<div>● 포장자재 신청이 없을 경우 원포장으로 발송하며 이 경우 상품 혹은 구성품의 분실이 발생할 수 있으며 이 경우 고로켓고의 과실이 아닙니다.</div>
							<div>● 상품이 고로켓고 중국 물류센터 도착 후 현지 물동량에 따라 평균 입고/검수 1일이내, 배송요청 후 평균 1일 이내 포장완료되어 배송비 결제요청됩니다.<br>
								(단일상품은 입고, 검수, 포장, 발송까지 평균 1일 소요)</div>
							<div>● 신청서는 작성하신 내용 그대로 세관에 신고되므로, 허위 신고로 인한 모든 책임은 작성자 본인에게 있습니다.</div>
							<div>● 고로켓고 검수완료후 도착사진을 반드시 직접 확인하셔서 상품의 이상유무를 확인해 주셔야합니다.</div>
							<div>● 배송신청을 하실 경우 도착상품의 이상유무를 직접 확인하신 것으로 판단하여 출고되며 추후 검수미비로 인한 보상은 해당되지 않습니다.</div>	
					</div>
					<div class="caution-agree">
						<div class="checkbox">
							<label >
								<el-checkbox v-model="formData.data.is_agree">모든 작성사항을 확인하였으며 주의사항에 동의합니다.</el-checkbox>
							</label>
						</div>
					</div>
					
				  
				  <el-dialog title="배송지 주소록" :width="isMobile?'90%':'50%'" :visible.sync="addressVisible">
					<template v-if="address_total>0">
						<strong>전체 : {{address_total}}</strong>
						<el-table
						  :data="addressData" :show-header="false"
						  style="padding: 0 10px;width: 100%;margin-bottom: 20px;height: 400px; overflow: auto;  ">
							  <el-table-column
							    label="">
								<template slot-scope="scope">
								  <p>{{ scope.row.consignee }}</p>
								  <p>개인통관고유부호:{{ scope.row.customs_info }}</p>
								  <p>{{ scope.row.mobile }}</p>
								  <p>[{{scope.row.zipcode}}] {{scope.row.address}} {{scope.row.detailed_address}}</p>
								</template>	
							  </el-table-column>
							<el-table-column   
							    label="操作"
							    width="80">
							    <template slot-scope="scope">
							      <el-button  @click="selAddress(scope.row)" type="text" size="small">선택</el-button><br>
							    </template>
							</el-table-column>	
						</el-table>
					</template>
					<el-button v-else type="primary" @click="onNewNav('/addressBook')" round>배송지 주소록 등록</el-button>
					
				  </el-dialog>
				  
		
				  
				  <!-- 操作按钮区 -->
				  <!-- <el-form-item>
					<el-button 
					  type="primary" 
					  icon="el-icon-plus" 
					  @click="addItem"
					>
					  복사
					</el-button>	
			
					<el-button 
					  type="warning" 
					  icon="el-icon-refresh" 
					  @click="resetForm"
					  style="margin-left: 10px"
					>
					  重置表单
					</el-button>
				  </el-form-item> -->
			</el-form>
				

				
				<!-- 상품 개별 부가서비스 설정 모달 -->
				<el-dialog
				  title="상품 부가서비스 신청"
				  :visible.sync="extraServiceDialogVisible"
				  :close-on-click-modal="false"
				  :close-on-press-escape="false"
				  :width="isMobile ? '95%' : '65%'"
				  center>
				  <div class="type-card" v-if="currentExtraItem" style="box-shadow: none; border: none; margin-bottom: 0;">
					<div class="card-body" style="padding: 0px 10px;" >
						<!-- <div class="card-help">
							부가서비스 상세내역을 꼭! 확인하세요.
							<a href="/bizAddService" class="type-1 link-btn" style="width: 100px;" target="_blank">
							바로가기<i class="el-icon-top-right"></i>
							</a>
						</div> -->
						<el-row class="col-wrap">
							<el-col :xs="24" :sm="8">
								<div class="group">
									<h4>제거</h4>
									<el-checkbox-group v-model="currentExtraItem.remove">
										<label class="checkbox-inline" v-for="(subItem, subIndex) in agency_attach.remove" :key="subIndex" > 
											<el-checkbox :label="subItem.id" >{{subItem.name}}  
												<el-popover
														placement="top"
														width="420"
														trigger="hover"
														>
														<div style="padding:10px 20px;" v-html="subItem.remarks"></div>
														<i class="el-icon-question icon-question"  slot="reference"></i>
												</el-popover>
											</el-checkbox>
											<span>{{subItem.subtitle}}</span>
										</label>
									</el-checkbox-group>
								</div>
								<div class="group">
									<h4>검수</h4>							
									<el-radio-group v-model="currentExtraItem.check_level" style="width: 100%;" >
										<label class="checkbox-inline" v-for="(subItem, subIndex) in agency_attach.check_level" :key="subIndex">
											<el-radio :label="subItem.id" >{{subItem.name}}
												<el-popover
														placement="top"
														width="400"
														trigger="hover"
														>
														<div style="padding:10px 20px;" v-html="subItem.remarks"></div>
														<i class="el-icon-question icon-question"  slot="reference"></i>
												</el-popover>
											</el-radio>
											<span>{{subItem.subtitle}}</span>
										</label>
									</el-radio-group>
								</div>
							</el-col>
							<el-col :xs="24" :sm="8" >
								<div class="group">
									<h4>포장</h4>
									<el-radio-group v-model="currentExtraItem.packing_level" style="width: 100%;" >
										<label class="checkbox-inline" v-for="(subItem, subIndex) in agency_attach.packing_level" :key="subIndex">
											<el-radio :label="subItem.id" >{{subItem.name}}
												<el-popover
														placement="top"
														width="400"
														trigger="hover"
														>
														<div style="padding:10px 20px;" v-html="subItem.remarks"></div>
														<i class="el-icon-question icon-question"  slot="reference"></i>
												</el-popover>
											</el-radio>
											<span>{{subItem.subtitle}}</span>
										</label>		
									</el-radio-group>
									<el-checkbox-group v-model="currentExtraItem.add_packing" >
										<label class="checkbox-inline" v-for="(subItem, subIndex) in agency_attach.add_packing" :key="subIndex">
											<el-checkbox :label="subItem.id" >{{subItem.name}}
												<el-popover
														placement="top"
														width="400"
														trigger="hover"
														>
														<div style="padding:10px 20px;" v-html="subItem.remarks"></div>
														<i class="el-icon-question icon-question"  slot="reference"></i>
												</el-popover>
											</el-checkbox>
											<span>{{subItem.subtitle}}</span>
										</label>			
									</el-checkbox-group>
								</div>
							</el-col>
							<el-col :xs="24" :sm="8" >
								<div class="group">
									<h4>기타</h4>
									<el-checkbox-group v-model="currentExtraItem.template" >
										<div style="display: flex;align-items: center;" v-for="(subItem, subIndex) in agency_attach.template" :key="subIndex" >
											<label class="checkbox-inline checkbox-inline-margin" style="width:80%;">
												<el-checkbox :label="subItem.id" >{{subItem.name}}
													<el-popover
															placement="top"
															width="400"
															trigger="hover"
															>
															<div style="padding:10px 20px;" v-html="subItem.remarks"></div>
															<i class="el-icon-question icon-question"  slot="reference"></i>
													</el-popover>
												</el-checkbox>
												<span style="white-space: nowrap;">{{subItem.subtitle}}</span>
											</label>
											<el-input v-model="currentExtraItem[`template${subItem.id}_cnt`]" style="width:20%;margin-top: 10px;">
												<template slot="suffix">개</template>
											</el-input>
										</div>
									</el-checkbox-group>
									<el-checkbox-group v-model="currentExtraItem.customs" >
										<label class="checkbox-inline" style="width: 100%;" v-for="(subItem, subIndex) in agency_attach.customs" :key="subIndex">
											<el-checkbox :label="subItem.id" >{{subItem.name}}
												<el-popover
														placement="top"
														width="400"
														trigger="hover"
														>
														<div style="padding:10px 20px;" v-html="subItem.remarks"></div>
														<i class="el-icon-question icon-question"  slot="reference"></i>
												</el-popover>
											</el-checkbox>
											<span>{{subItem.subtitle}}</span>
										</label>				
									</el-checkbox-group>
								</div>
							</el-col>
						</el-row>
					</div>
				  </div>
				  <span slot="footer" class="dialog-footer">
					<el-button type="danger" plain round @click="clearCurrentExtraItemServices" style="margin-right: 10px;">모두 지우기</el-button>
					<el-button type="primary" round @click="extraServiceDialogVisible = false">확인</el-button>
				  </span>
				</el-dialog>

				<el-dialog
				  :visible.sync="centerDialogVisible" :close-on-press-escape="false" :close-on-click-modal="false"
				  :width="isMobile?'90%':'50%'" 
				  @close="onCloseImport"
				  center>
				  <div>
						<div class="section-header">
							<h1><span>타오바오/1688</span> 주문서 자동등록</h1>
							<p>중국 쇼핑몰의 주문 상세내역을 전체 복사(Ctrl+C)하여 하단의 공란에<br>
							붙여넣기(Ctrl+V)하신 후 가져오기 버튼을 눌러주세요</p>
							<a href="/deliveryAuto" target="_blank"><img src="../../assets/icon/info-icon.png" alt="자동등록 이용방법">자동등록 이용방법</a>
						</div>
						<el-select v-model="site_value" @change="changeSite" placeholder="">
						    <el-option
						      v-for="item in options"
						      :key="item.value"
						      :label="item.label"
						      :value="item.value">
						    </el-option>
						</el-select>
						<!-- 核心：可编辑的 div -->
						<div  @paste="handlePaste" ref="handlePaste"  contenteditable="true" style="margin-top: 10px; height: 200px;  overflow-y: auto;  border: 1px solid #ddd; border-radius: 10px; padding: 10px;">
						   <!-- 在这里粘贴或输入富文本内容 -->
						</div>
							
				  </div>
				  <span slot="footer" class="dialog-footer" >
				    <el-button round @click="onCloseImport">닫기</el-button>
				    <el-button style=" background:#ff5700;color:#FFF;" round @click="onImportOrder">가져오기</el-button>
				  </span>
				</el-dialog>
				
				
				<div class="text-center">
					<el-button @click="onReturn" round>뒤로가기</el-button>
					<el-button
					  type="primary" 
					  @click="submitForm" round
					  style="margin-left: 30px"
					>
					  수정하기
					</el-button>
				</div>
				
				
				
			</div>
			<el-empty v-else description="매개변수 오류"></el-empty>
			
				
		</div>
		
	
	
	
	</div>
</template>

<script>
	import AgencyBanner from '../../components/AgencyBanner.vue'
	import { safePush } from '@/utils/router';
	import request from '@/utils/request';
	import Constants from '@/constants'
	import categoryData from '@/assets/fenlei_final_with_10_names_no_cat4.min.json'
	export default {
	  //name: 'DynamicForm',
		components: {
			AgencyBanner,
		},
		data() {
			return {
				AirVisible: false,
				 
				CategoryVisible: false,
				category_index:'',
				category_list:[],
				search: '',
				flattenedCategories: [],
				categorySearch: '',
				
				sales_tax:'',
				shipping:'',
				discount:'',
				agency_attach:[],
				//total_amount:998.90,
			  // 表单数据模型
			  formData: {
				items: [], // 动态表单项数组
				data:{
					
					remove:[],
					check_level:5,
					packing_level:6,
					add_packing:[],
					template:[],
					template15_cnt:1,
					template16_cnt:1,
					template17_cnt:1,
					template18_cnt:1,
					template19_cnt:1,
					template20_cnt:1,
					template21_cnt:1,
					customs:[],
					address_id:'',
					express_demand:'',
					pay_service:['2'],
					service_cargo_type:'2',
					service_fta_type:'2',
					service_tariff_notify:'2',
					service_delivery_notify:'2',
					is_agree:'',
				}
				
			  },
				//checkList: [],  
			  
				show:"",
				agreement_yn:"",
				deliveryCenterCode:"",
				customsType:"",
				customsTypeName:"",
				addressData: [],
				addressVisible: false,
				address_info:{},
				address_total:0,
				
				centerDialogVisible: false,
				options: [{
				  value: '',
				  label: 'totalSupport'
				}, {
				  value: '1688',
				  label: '阿里巴巴'
				}, {
				  value: 'taobao',
				  label: '淘宝网'
				}],
				site_value: '',
				pasted_html:'',
				uploadVisible: false,
				upload_index:'',
				upload: 1,
				imageUrl:'',
				update_url:'',
				extraServiceDialogVisible: false,
				currentExtraServiceItemIndex: '',
			}
		},
		created() {
			const id = this.$route.query.id;
			if (!id) {
				this.$message.error('주문 ID가 없습니다.');
				this.show = false;
				return;
			}
			console.log("Edit Mode for ID:", id);
			this.getAgencyAttach().then(() => {
				this.loadAgencyDetail(id);
			}).catch(() => {
				this.loadAgencyDetail(id);
			});
		},
		computed: {
			filteredCategories() {
				if (!this.categorySearch) {
					return this.flattenedCategories
				}
				const query = this.categorySearch.toLowerCase()
				return this.flattenedCategories.filter(item => {
					return (
						(item.l1 && item.l1.toLowerCase().includes(query)) ||
						(item.l2 && item.l2.toLowerCase().includes(query)) ||
						(item.l2_code && item.l2_code.toLowerCase().includes(query)) ||
						(item.l2_cn && item.l2_cn.toLowerCase().includes(query)) ||
						(item.l2_en && item.l2_en.toLowerCase().includes(query)) ||
						(item.l3 && item.l3.toLowerCase().includes(query)) ||
						(item.l3_code && item.l3_code.toLowerCase().includes(query))
					)
				})
			},
			/**
			* 计算总金额：所有商品的（单价 × 数量）之和
			*/
			totalAmount() {
				return this.formData.items.reduce((sum, goods) => {
				// 处理未输入的情况（默认0）
				const price = Number(goods.price) || 0
				const quantity = Number(goods.apply_quantity) || 0
				return sum + (price * quantity)
			}, 0)
			},
		  isMobile() {
			return window.innerWidth <= 768;
		  },
		  currentExtraItem() {
			if (this.currentExtraServiceItemIndex !== '' && this.currentExtraServiceItemIndex !== null && this.currentExtraServiceItemIndex !== undefined) {
				return this.formData.items[this.currentExtraServiceItemIndex];
			}
			return null;
		  }
		},
		mounted() {
			this.update_url = Constants.BASE_URL
		},
		methods: {
			/**
			 * 提交图片上传
			 * @description 处理图片URL提交 (upload == 2) 和 直接上传后的确认 (upload == 1)
			 */
			submitUpload(){
				if(this.upload == 2){
					this.uploadVisible = false
					request.post('/Images/uploadByUrl', {url:this.imageUrl}).then(response => {
						if(response.code == 1){
							alert('등록 완료！');
							this.imageUrl = ""
							this.formData.items[this.upload_index].imageUrl = response.data.fullurl
							this.formData.items[this.upload_index].goods_image = response.data.url
						}else{
							alert(response.msg)
							return
						}		
					});
				}else if(this.upload == 1){
					this.uploadVisible = false
					this.formData.items[this.upload_index].imageUrl = this.imageUrl
					this.imageUrl = ""
				}
			},
			/**
			 * 点击“图片注册”按钮触发，展示上传弹窗
			 * @param {Number} index - 当前操作的表单商品项索引
			 */
			onUpload(index){
				this.upload_index = index
				this.uploadVisible = true
			},
			/**
			 * 图片上传成功时的回调钩子
			 * @param {Object} res - 服务器返回的响应信息
			 * @param {Object} file - 上传的文件对象
			 */
			handleAvatarSuccess(res, file) {
				this.imageUrl = file.response.data.fullurl;
				this.formData.items[this.upload_index].goods_image = file.response.data.url;
			},
			/**
			 * 上传文件之前的校验钩子
			 * @description 限制上传图片格式只能是 JPG 或 PNG，且大小不能超过 2MB
			 * @param {Object} file - 准备上传的文件对象
			 * @returns {Boolean} 若返回 false 则停止上传
			 */
			beforeAvatarUpload(file) {
				const isJPG = file.type === 'image/jpeg' || file.type === 'image/jpg';
				const isPNG = file.type === 'image/png';
				const isLt2M = file.size / 1024 / 1024 < 2;
				if (!isJPG && !isPNG) {
				  this.$message.error('업로드 이미지 형식은 JPG 또는 PNG여야 합니다!');
				  return false
				}
				if (!isLt2M) {
				  this.$message.error('업로드 이미지 크기는 2MB를 초과할 수 없습니다!');
				   return false
				}
			},
			/**
			 * 切换上传方式时的事件处理
			 * @param {Number} value - 当前选中的上传方式（1: 直接上传, 2: URL输入）
			 */
			changeUpload(value){
				console.log(value,"切换")
			},
			// 处理粘贴事件
			handlePaste(e) {
				console.log(e)
				// 剪贴板文本解析作为辅助，直接由 contenteditable div 的 innerHTML 处理
				const clipboardData = e.clipboardData || window.clipboardData;
				const pastedText = clipboardData.getData("text/html") || clipboardData.getData("text/plain");
				if (!pastedText) return;
			
				const parser = new DOMParser()
				const doc = parser.parseFromString(pastedText, 'text/html')
				this.pasted_html = doc;
				console.log("成功捕获粘贴内容:", this.pasted_html);
			},
			onCloseImport(){
				console.log("关闭导入")
				this.pasted_html = '';
				if (this.$refs.handlePaste) this.$refs.handlePaste.innerHTML = '';
				this.centerDialogVisible = false
			},	
			onImportOrder(){
				console.log(this.site_value,"导入淘宝1688订单")
				if(!this.site_value){
					alert("쇼핑몰을 선택하세요.");
					return;
				}
				
				// 始终从编辑区域的最新 innerHTML 获取并解析内容，避免状态不同步
				if (this.$refs.handlePaste) {
					const parser = new DOMParser()
					const doc = parser.parseFromString(this.$refs.handlePaste.innerHTML, 'text/html')
					this.pasted_html = doc;
					console.log("从编辑器获取最新内容进行提交:", this.pasted_html);
				}
				
				let doc = this.pasted_html;
				if (!doc) {
					alert("제출할 내용이 없습니다!");//没有可提交的内容！
					return;
				}
			
				let parsedCount = 0;
				if(this.site_value == "1688"){
					let sondata = doc.querySelectorAll(".order-list-content order-item .order-item-entry-container .order-item-entry");
					if (sondata.length === 0) {
						sondata = doc.querySelectorAll(".order-item-entry");
					}
					parsedCount = sondata.length;
					if (sondata.length > 0) {
						// 删除顶部空的表单项
						this.formData.items = this.formData.items.filter(item => item.goods_name || item.order_no || item.tracking_no)
						
						const newItems = []
						for (let i = 0; i < sondata.length; i++) {
							newItems.push({
								id: this.generateId(),
								order_no: this.extractOrderNo(doc, i),
								goods_name: this.extractGoodsName(doc, i),
								price: this.extractPrice(doc, i),
								apply_quantity: this.extractNum(doc, i),
								url: this.extractUrl(doc, i),
								box_count: "",
								// check: "",
								color: this.extractColor(doc, i),
								// origin: "",
								// package: "",
								product_code: "",
								refer_code: "",
								shipping_memo: "",
								size: this.extractSize(doc, i),
								tracking_no: "",
								category_id: '',
								category_name: '',
								hs_code: '',
								goods_image: this.extractImg(doc, i),
								imageUrl: this.extractImg(doc, i),
								showPopover: false,
								show_extra_services: false,
								remove: [],
								check_level: '',
								packing_level: '',
								add_packing: [],
								template: [],
								template15_cnt: 1,
								template16_cnt: 1,
								template17_cnt: 1,
								template18_cnt: 1,
								template19_cnt: 1,
								template20_cnt: 1,
								template21_cnt: 1,
								customs: [],
							})
						}
						this.formData.items.push(...newItems)
					}
				} else if (this.site_value == "taobao") {
					console.log("taobao")
					// 先尝试完整路径，部分复制时外层容器可能不存在，回退到直接匹配
					let sondata = doc.querySelectorAll(".trade-content-container .trade-container .trade-bought-list-order-info");
					if (sondata.length === 0) {
						sondata = doc.querySelectorAll(".trade-bought-list-order-info");
					}
					parsedCount = sondata.length;
					if(sondata.length>0){
						// 删除顶部空的表单项
						this.formData.items = this.formData.items.filter(item => item.goods_name || item.order_no || item.tracking_no)
						
						const newItems = []
						for (let i = 0; i < sondata.length; i++) {
							newItems.push({
								id: this.generateId(),
								order_no: this.extractTbOrderNo(doc, i),
								goods_name: this.extractTbGoodsName(doc, i),
								price: this.extractTbPrice(doc, i),
								apply_quantity: this.extractTbNum(doc, i),
								url: this.extractTbUrl(doc, i),
								box_count: "",
								// check: "",
								color: this.extractTbColor(doc, i),
								// origin: "",
								// package: "",
								product_code: "",
								refer_code: "",
								shipping_memo: "",
								size: this.extractTbSize(doc, i),
								tracking_no: "",
								category_id: '',
								category_name: '',
								hs_code: '',
								goods_image: this.extractTbImg(doc, i),
								imageUrl: this.extractTbImg(doc, i),
								showPopover: false,
								show_extra_services: false,
								remove: [],
								check_level: '',
								packing_level: '',
								add_packing: [],
								template: [],
								template15_cnt: 1,
								template16_cnt: 1,
								template17_cnt: 1,
								template18_cnt: 1,
								template19_cnt: 1,
								template20_cnt: 1,
								template21_cnt: 1,
								customs: [],
							})
						}
						this.formData.items.push(...newItems)
					}
				}
			
				if (parsedCount > 0) {
					this.pasted_html = ''//粘贴内容
					if (this.$refs.handlePaste) this.$refs.handlePaste.innerHTML = ''//文本框中内容
					this.centerDialogVisible = false
					this.$nextTick(() => {
						this.$message({ type: 'success', message: '주문 데이터를 성공적으로 가져왔습니다!', duration: 2000 });
					});
				} else {
					this.$message.warning("주문 데이터를 찾을 수 없습니다. 복사한 내용을 확인해주세요.");
				}
			},
			// 提取订单号
			extractOrderNo(doc,i) {
				let orderNo = doc.querySelectorAll(".order-list-content order-item .order-item-entry-container .order-item-entry");
				if (orderNo.length === 0) {
					orderNo = doc.querySelectorAll(".order-item-entry");
				}
				// 遍历子级，获取每个子级的父级
				var orderid =""
				orderNo.forEach((childEl, index) => {
					const parentEl = childEl.parentElement.parentElement.previousElementSibling.querySelector('.order-id copy-to-clipboard'); // 获取上一级父元素
					if(index == i){   
						console.log("父级元素：", parentEl.getAttribute('text') );
						orderid = parentEl.getAttribute('text')
					}
				});
				return orderid
			},
			// 提取商品名称
			extractGoodsName(doc,i) {
			  let goodsName = doc.querySelectorAll('.order-list-content order-item .order-item-entry-container .order-item-entry .product-name')
			  if (goodsName.length === 0) {
				  goodsName = doc.querySelectorAll('.order-item-entry .product-name')
			  }
			  return goodsName && goodsName[i] ? goodsName[i].textContent.trim() : ''
			},
			// 提取单价
			extractPrice(doc,i) {
			  let price = doc.querySelectorAll('.order-list-content order-item .order-item-entry-container .order-item-entry .actual-unit-price')
			  if (price.length === 0) {
				  price = doc.querySelectorAll('.order-item-entry .actual-unit-price')
			  }
			  return price && price[i] ? price[i].textContent.trim().replace('¥', '').trim() : ''
			},
			extractNum(doc,i){
				let num = doc.querySelectorAll('.order-list-content order-item .order-item-entry-container .order-item-entry .quantity-amount')
				if (num.length === 0) {
					num = doc.querySelectorAll('.order-item-entry .quantity-amount')
				}
				return num && num[i] ? num[i].textContent.trim() : ''
			},
			extractUrl(doc,i){
				let url = doc.querySelectorAll('.order-list-content order-item .order-item-entry-container .order-item-entry .product-name')
				if (url.length === 0) {
					url = doc.querySelectorAll('.order-item-entry .product-name')
				}
				return url && url[i] ? url[i].getAttribute('href').replace('new.goods.productname', '') : ''
			},
			extractImg(doc, i) {
				let img = doc.querySelectorAll('.order-list-content order-item .order-item-entry-container .order-item-entry img')
				if (img.length === 0) {
					img = doc.querySelectorAll('.order-item-entry img')
				}
				let src = img && img[i] ? img[i].getAttribute('src') : '';
				if (src) {
					src = src.replace('_160x160.jpg_.webp', '');
				}
				return src;
			},
			// 提取订单号
			extractTbOrderNo(doc,i) {
				//const orderNo = doc.querySelectorAll(".order-list-content order-item .order-item-entry-container .order-item-entry");
				let orderNo = doc.querySelectorAll(".trade-content-container .trade-container .trade-bought-list-order-info");
				if (orderNo.length === 0) orderNo = doc.querySelectorAll(".trade-bought-list-order-info");
				// 遍历子级，获取每个子级的父级
				var orderid =""
				orderNo.forEach((childEl, index) => {
					const parentEl = childEl.parentElement.parentElement.previousElementSibling.querySelector('div:first-of-type span:nth-of-type(2)'); // 获取上一级父元素
					if(index == i){   
						//console.log("父级元素：", parentEl.textContent.trim().replace('订单号: ', '') );
						orderid = parentEl.textContent.trim().replace('订单号: ', '')
					}
				});
				return orderid
			},
			// 提取商品名称
			extractTbGoodsName(doc,i) {
			  let goodsName = doc.querySelectorAll('.trade-content-container .trade-container .trade-bought-list-order-info>div>div>div>div>a>span:first-of-type')
			  if (goodsName.length === 0) goodsName = doc.querySelectorAll('.trade-bought-list-order-info>div>div>div>div>a>span:first-of-type')
			  return goodsName && goodsName[i] ? goodsName[i].textContent.trim() : ''
			},
			// 提取单价
			extractTbPrice(doc,i) {
			  let integer = doc.querySelectorAll('.trade-content-container .trade-container .trade-bought-list-order-info>div>div:not(.trade-price-container-underline) .trade-price-integer')
			  if (integer.length === 0) integer = doc.querySelectorAll('.trade-bought-list-order-info>div>div:not(.trade-price-container-underline) .trade-price-integer')
			  let decimal = doc.querySelectorAll('.trade-content-container .trade-container .trade-bought-list-order-info>div>div:not(.trade-price-container-underline) .trade-price-decimal')
			  if (decimal.length === 0) decimal = doc.querySelectorAll('.trade-bought-list-order-info>div>div:not(.trade-price-container-underline) .trade-price-decimal')
			  return (integer[i] ? integer[i].textContent : '0') + '.' + (decimal[i] ? decimal[i].textContent : '00')
			},
			extractTbNum(doc,i){
				let num = doc.querySelectorAll('.trade-content-container .trade-container .trade-bought-list-order-info>div:nth-of-type(2)>div:last-of-type')
				if (num.length === 0) num = doc.querySelectorAll('.trade-bought-list-order-info>div:nth-of-type(2)>div:last-of-type')
				return num && num[i] ? num[i].textContent.trim().replace('x', '') : ''
			},
			extractTbUrl(doc,i){
				let url = doc.querySelectorAll('.trade-content-container .trade-container .trade-bought-list-order-info>div>div:nth-of-type(2)>div:first-of-type>div>a')
				if (url.length === 0) url = doc.querySelectorAll('.trade-bought-list-order-info>div>div:nth-of-type(2)>div:first-of-type>div>a')
				return url && url[i] && url[i].getAttribute('href') ? url[i].getAttribute('href') : ''
			},
			/**
			 * 从淘宝订单HTML中提取商品图片URL
			 * @description 淘宝使用 background-image CSS样式 而非 <img> 标签展示商品图片
			 * @param {Object} doc - 解析后的HTML文档对象
			 * @param {Number} i - 当前商品索引
			 * @returns {String} 完整的图片URL
			 */
			extractTbImg(doc, i) {
				// 方式1: 从 background-image 样式中提取图片URL（淘宝新版页面）
				const bgElements = doc.querySelectorAll('.trade-bought-list-order-info span[data-spm="suborder_itempic"] a')
				if (bgElements && bgElements[i]) {
					const style = bgElements[i].getAttribute('style');
					if (style) {
						const match = style.match(/background-image:\s*url\(["']?(.*?)["']?\)/);
						if (match && match[1]) {
							let url = match[1];
							if (url.startsWith('//')) {
								url = 'https:' + url;
							}
							return url;
						}
					}
				}
				// 方式2: 尝试从 <img> 标签获取图片（兼容旧版页面）
				const img = doc.querySelectorAll('.trade-bought-list-order-info img')
				if (img && img[i]) {
					const src = img[i].getAttribute('src');
					if (src && src.startsWith('//')) {
						return 'https:' + src;
					}
					return src;
				}
				return ''
			},
			extractColor(doc, i) {
				let itemNodes = doc.querySelectorAll(".order-list-content order-item .order-item-entry-container .order-item-entry");
				if (itemNodes.length === 0) itemNodes = doc.querySelectorAll(".order-item-entry");
				const node = itemNodes[i];
				if (!node) return '';
				
				const noiseRegex = /理由|退换|退货|极速|退款|保|赠品|快照|假一赔|服务|分期|保险|赠送/;
				const specEls = Array.from(node.querySelectorAll('.sku-info-item, .product-prop, .spec-info, .spec-item'))
					.map(el => el.textContent.trim())
					.filter(txt => txt && !noiseRegex.test(txt));
				
				let color = "";
				if (specEls.length > 0) {
					// 0. 特殊处理：分号分隔 (尺寸;颜色)
					const semiPair = specEls.find(txt => (txt.includes(';') || txt.includes('；')) && !/[:：]/.test(txt));
					if (semiPair) {
						const parts = semiPair.split(/[;；]/).map(p => p.trim());
						if (parts.length >= 2) color = parts[1];
					}

					if (!color) {
						const idx = specEls.findIndex(txt => /颜色[:：]/.test(txt));
						if (idx !== -1) {
							color = specEls[idx].replace(/颜色[:：]\s*/, '').trim();
						} else {
							// 没有分号默认填尺寸
							if (specEls.length > 1) color = specEls[0];
							else color = "";
						}
					}
				}
				
				if (!color) {
					const text = node.innerText || '';
					const match = text.match(/颜色[:：]\s*([^;；\n\t]+)/);
					color = match ? match[1].trim() : '';
				}
				return color;
			},
			extractSize(doc, i) {
				let itemNodes = doc.querySelectorAll(".order-list-content order-item .order-item-entry-container .order-item-entry");
				if (itemNodes.length === 0) itemNodes = doc.querySelectorAll(".order-item-entry");
				const node = itemNodes[i];
				if (!node) return '';
				
				const noiseRegex = /理由|退换|退货|极速|退款|保|赠品|快照|假一赔|服务|分期|保险|赠送/;
				const specEls = Array.from(node.querySelectorAll('.sku-info-item, .product-prop, .spec-info, .spec-item'))
					.map(el => el.textContent.trim())
					.filter(txt => txt && !noiseRegex.test(txt));
				
				let size = "";
				if (specEls.length > 0) {
					// 0. 特殊处理：分号分隔 (尺寸;颜色)
					const semiPair = specEls.find(txt => (txt.includes(';') || txt.includes('；')) && !/[:：]/.test(txt));
					if (semiPair) {
						const parts = semiPair.split(/[;；]/).map(p => p.trim());
						if (parts.length >= 2) size = parts[0];
					}

					if (!size) {
						const idx = specEls.findIndex(txt => /尺码[:：]/.test(txt));
						if (idx !== -1) {
							size = specEls[idx].replace(/尺码[:：]\s*/, '').trim();
						} else {
							// 没有分号默认填尺寸
							if (specEls.length === 1) size = specEls[0];
							else if (specEls.length > 1) {
								const colorIdx = specEls.findIndex(txt => /颜色[:：]/.test(txt));
								if ((colorIdx === 0 || colorIdx === -1)) size = specEls[1];
							}
						}
					}
				}
				
				if (!size) {
					const text = node.innerText || '';
					const match = text.match(/尺码[:：]\s*([^;；\n\t]+)/);
					size = match ? match[1].trim() : '';
				}
				return size;
			},
			extractTbColor(doc, i) {
				let itemNodes = doc.querySelectorAll(".trade-content-container .trade-container .trade-bought-list-order-info");
				if (itemNodes.length === 0) itemNodes = doc.querySelectorAll(".trade-bought-list-order-info");
				const node = itemNodes[i];
				if (!node) return '';
				
				const noiseRegex = /理由|退换|退货|极速|退款|保|赠品|快照|假一赔|服务|分期|保险|赠送/;
				const skuEls = Array.from(node.querySelectorAll('.sku-info-item, .info, .sku-info, [class*="sku--"], .trade-clamp-wrap, .trade-clamp-ellipsis'))
					.map(el => el.textContent.trim())
					.filter(txt => txt && !noiseRegex.test(txt));
				
				let color = "";
				if (skuEls.length > 0) {
					// 0. 特殊处理：分号分隔 (颜色;尺寸)
					const semiPair = skuEls.find(txt => (txt.includes(';') || txt.includes('；')) && !/[:：]/.test(txt));
					if (semiPair) {
						const parts = semiPair.split(/[;；]/).map(p => p.trim());
						if (parts.length >= 2) color = parts[0];
					}

					if (!color) {
						const idx = skuEls.findIndex(txt => /(?:颜色分类|颜色)[:：]/.test(txt));
						if (idx !== -1) {
							color = skuEls[idx].replace(/(?:颜色分类|颜色)[:：]\s*/, '').trim();
						} else {
							// 没有逗号默认填尺寸，所以如果只有一项且没有逗号，颜色应为空
							if (skuEls.length > 1) color = skuEls[0];
							else color = ""; 
						}
					}
				}
				
				if (!color) {
					const text = node.innerText || '';
					const match = text.match(/(?:颜色分类|颜色)[:：]\s*([^;；\n\t]+)/);
					color = match ? match[1].trim() : '';
				}
				return color;
			},
			extractTbSize(doc, i) {
				let itemNodes = doc.querySelectorAll(".trade-content-container .trade-container .trade-bought-list-order-info");
				if (itemNodes.length === 0) itemNodes = doc.querySelectorAll(".trade-bought-list-order-info");
				const node = itemNodes[i];
				if (!node) return '';
				
				const noiseRegex = /理由|退换|退货|极速|退款|保|赠品|快照|假一赔|服务|分期|保险|赠送/;
				const skuEls = Array.from(node.querySelectorAll('.sku-info-item, .info, .sku-info, [class*="sku--"], .trade-clamp-wrap, .trade-clamp-ellipsis'))
					.map(el => el.textContent.trim())
					.filter(txt => txt && !noiseRegex.test(txt));
				
				let size = "";
				if (skuEls.length > 0) {
					// 0. 特殊处理：分号分隔 (颜色;尺寸)
					const semiPair = skuEls.find(txt => (txt.includes(';') || txt.includes('；')) && !/[:：]/.test(txt));
					if (semiPair) {
						const parts = semiPair.split(/[;；]/).map(p => p.trim());
						if (parts.length >= 2) size = parts[1];
					}

					if (!size) {
						const idx = skuEls.findIndex(txt => /(?:尺码|尺寸)[:：]/.test(txt));
						if (idx !== -1) {
							size = skuEls[idx].replace(/(?:尺码|尺寸)[:：]\s*/, '').trim();
						} else {
							// 没有逗号默认填尺寸
							if (skuEls.length === 1) size = skuEls[0];
							else if (skuEls.length > 1) {
								const colorIdx = skuEls.findIndex(txt => /(?:颜色分类|颜色)[:：]/.test(txt));
								if ((colorIdx === 0 || colorIdx === -1)) size = skuEls[1];
							}
						}
					}
				}
				
				if (!size) {
					const text = node.innerText || '';
					const match = text.match(/(?:尺码|尺寸)[:：]\s*([^;；\n\t]+)/);
					size = match ? match[1].trim() : '';
				}
				return size;
			},
			onOrderlayer(){
				this.centerDialogVisible = true	
			},
			changeSite(value){
				console.log(value,22222)
				this.site_value = value
			},
			onNewNav(url){
				window.open(url, '_blank');
			},
			onCargoType(value){
				console.log(value,"22222222")
				if(value == 1){//预付
					alert("팀머니 100,000원 이상이어야 신청 가능합니다.");
					this.formData.data.service_cargo_type = '2'
				}
			},
			onReturn(){
				safePush(this.$router, '/agencyShipping');
			},
			getAgencyAttach(){
				console.log("附加服务申请历史记录")
				return request.post('/member/Agency/getAgencyAttach',{}
				).then(res => {
					console.log(res,"记录1")
					if(res.code ==1){
						 this.agency_attach = res.data
					}		
				});
			},
			loadAgencyDetail(id) {
				request.post('/member/Agency/getAgencyDetailForEdit', { id }).then(res => {
					if (res.code === 1) {
						const data = res.data;
						this.deliveryCenterCode = data.delivery_center_code;
						this.customsType = data.customs_type;
						if (this.customsType == 2) {
							this.customsTypeName = '목록통관';
						} else if (this.customsType == 1) {
							this.customsTypeName = '간이통관';
						} else if (this.customsType == 3) {
							this.customsTypeName = '사업자통관';
						}
						
						if (this.deliveryCenterCode === 'CN_AIR') {
							this.AirVisible = true;
						}

						// Pre-fill main form attributes
						this.formData.data.remove = data.remove || [];
						this.formData.data.check_level = data.check_level ? Number(data.check_level) : '';
						this.formData.data.packing_level = data.packing_level ? Number(data.packing_level) : '';
						this.formData.data.add_packing = data.add_packing || [];
						this.formData.data.template = data.template || [];
						
						// Pre-fill template counters
						if (this.agency_attach && this.agency_attach.template) {
							this.agency_attach.template.forEach(t => {
								const cntKey = `template${t.id}_cnt`;
								this.$set(this.formData.data, cntKey, data[cntKey] !== undefined ? Number(data[cntKey]) : 1);
							});
						}
						
						this.formData.data.customs = data.customs || [];
						this.formData.data.address_id = data.address_id;
						this.formData.data.express_demand = data.express_demand || '';
						this.formData.data.pay_service = data.pay_service || [];
						this.formData.data.service_cargo_type = String(data.service_cargo_type || '2');
						this.formData.data.service_fta_type = String(data.service_fta_type || '2');
						this.formData.data.service_tariff_notify = String(data.service_tariff_notify || '2');
						this.formData.data.is_agree = true; // Set to true by default for editing

						// Pre-fill address info
						this.address_info = data.address_info || {};

						// Pre-fill goods items
						this.formData.items = (data.goods || []).map(goods => {
							const item = {
								id: goods.id,
								goods_id: goods.id,
								category_id: goods.category_id,
								category_name: goods.category_name,
								hs_code: goods.hs_code || '',
								goods_name: goods.goods_name,
								tracking_no: goods.tracking_no || '',
								size: goods.size || '',
								order_no: goods.order_no || '',
								color: goods.color || '',
								price: String(goods.price || ''),
								product_code: goods.product_code || '',
								box_count: goods.box_count !== undefined ? Number(goods.box_count) : '',
								apply_quantity: goods.apply_quantity !== undefined ? Number(goods.apply_quantity) : 1,
								refer_code: goods.refer_code || '',
								url: goods.url || '',
								shipping_memo: goods.shipping_memo || '',
								// origin: goods.origin == 1,
								// package: goods.package == 1,
								// check: goods.check == 1,
								goods_image: goods.goods_image || '',
								imageUrl: goods.imageUrl || goods.goods_image || '',
								showPopover: false,
								show_extra_services: false,
								remove: goods.remove || [],
								check_level: goods.check_level !== undefined && goods.check_level !== null ? Number(goods.check_level) : '',
								packing_level: goods.packing_level !== undefined && goods.packing_level !== null ? Number(goods.packing_level) : '',
								add_packing: goods.add_packing || [],
								template: goods.template || [],
								customs: goods.customs || []
							};
							
							// Set item level template counts
							if (this.agency_attach && this.agency_attach.template) {
								this.agency_attach.template.forEach(t => {
									const cntKey = `template${t.id}_cnt`;
									this.$set(item, cntKey, goods[cntKey] !== undefined ? Number(goods[cntKey]) : 1);
								});
							}
							return item;
						});

						this.show = true;
					} else {
						this.$message.error(res.msg || '정보를 불러오지 못했습니다.');
						this.show = false;
					}
				}).catch(err => {
					console.error(err);
					this.$message.error('서버와의 통신 오류가 발생했습니다.');
					this.show = false;
				});
			},
			formatImgUrl(url) {
				if (!url) return '';
				if (url.startsWith('http') || url.startsWith('//') || url.startsWith('data:')) {
					return url;
				}
				const apiBase = Constants.BASE_URL || '';
				const domain = apiBase.replace(/\/api\/?$/, '');
				return domain + (url.startsWith('/') ? '' : '/') + url;
			},
			onCheck(value){
				console.log(value)
			},
			openAddress(){
				this.addressVisible = true
				this.getAddressList()
			},
			selAddress(row){
				//选择地址
				console.log(row,"选择地址")
				this.address_info = row
				this.formData.data.address_id = row.id
				this.addressVisible = false
			},
			getAddressList(){
				request.post('/member/Address/addressList',{}
				).then(res => {
					console.log(res,"列表")
					if(res.code ==1){
						this.address_total = res.data.length
						this.addressData= res.data
					}		
				});
				
			},
			calcAmount(){
				console.log(this.sales_tax)
				let sum = this.sales_tax +this.shipping-this.discount
				console.log(sum,"计算金额")
				alert("기대해주세요.")
			},
			onCurrentNav(url){
				this.$router.push(url);	
			},
			onSearch(){
				console.log(this.search)
				this.getCategoryList()
			},
			getCategoryList(){
				request.post('/member/Agency/getCategoryList',{
					search:this.search
				})
				.then(res => {
					console.log(res,"212")
					if(res.code ==1){
						this.category_list = res.data
					}
						
				});
				
			},
			onCategoryDialog(index){
				this.category_index = index
				this.CategoryVisible = true
				if (this.flattenedCategories.length === 0) {
					this.processCategories()
				}
			},
			processCategories() {
				const result = []
				let counter = 0
				categoryData.categories.forEach((cat) => {
					cat.items.forEach((item) => {
						if (item.hscode_10_details && item.hscode_10_details.length > 0) {
							item.hscode_10_details.forEach((h10) => {
								result.push({
									uniqueId: counter++,
									item_id: item.id,
									l1: cat.category_name,
									l2: item.name_ko,
									l2_code: item.hs_code,
									l2_cn: item.name_cn,
									l2_en: item.name_en,
									l3: h10.hscode_10_name,
									l3_code: h10.hscode_10
								})
							})
						} else {
							result.push({
								uniqueId: counter++,
								item_id: item.id,
								l1: cat.category_name,
								l2: item.name_ko,
								l2_code: item.hs_code,
								l2_cn: item.name_cn,
								l2_en: item.name_en,
								l3: '-',
								l3_code: '-'
							})
						}
					})
				})
				this.flattenedCategories = Object.freeze(result)
			},
			highlightCategoryText(text) {
				if (!this.categorySearch || text === undefined || text === null || text === '-') return text
				const str = String(text)
				const query = this.categorySearch.trim().toLowerCase()
				if (!query) return str
				const regex = new RegExp(query.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'gi')
				return str.replace(regex, match => `<span class="hl-text-category">${match}</span>`)
			},
			handleSelectCategory(row) {
				console.log("选择分类:", row)
				if (this.category_index !== '') {
					const item = this.formData.items[this.category_index];
					item.category_name = row.l2;
					item.goods_name = row.l2_en;
					// 优先提交第三级10位码，如果没有则提提交第二级码
					item.hs_code = (row.l3_code && row.l3_code !== '-') ? row.l3_code : row.l2_code;
					item.category_id = row.item_id;
					item.showPopover = false;
				}
			},
			onSearchInput(index) {
				this.categorySearch = this.formData.items[index].category_name
				this.formData.items[index].showPopover = true
				this.category_index = index
			},
			onCategoryName(id,name){
				// 暂时不需要选择分类，保持为空或根据需求调整
				// this.CategoryVisible = false
				// this.formData.items[this.category_index].category_id =id
				// this.formData.items[this.category_index].category_name =name
			},
			hasSelectedExtraServices(item) {
				return (
					(item.remove && item.remove.length > 0) ||
					(item.check_level !== '' && item.check_level !== null && item.check_level !== undefined) ||
					(item.packing_level !== '' && item.packing_level !== null && item.packing_level !== undefined) ||
					(item.add_packing && item.add_packing.length > 0) ||
					(item.template && item.template.length > 0) ||
					(item.customs && item.customs.length > 0)
				);
			},
			formatSelectedExtraServices(item) {
				if (!this.agency_attach) return '';
				const selected = [];
				
				const getName = (list, id) => {
					if (!list) return '';
					const found = list.find(x => x.id === id);
					return found ? found.name : '';
				};

				if (item.remove && item.remove.length > 0) {
					item.remove.forEach(id => {
						const name = getName(this.agency_attach.remove, id);
						if (name) selected.push(name);
					});
				}

				if (item.check_level !== '' && item.check_level !== null && item.check_level !== undefined) {
					const name = getName(this.agency_attach.check_level, item.check_level);
					if (name) selected.push(name);
				}

				if (item.packing_level !== '' && item.packing_level !== null && item.packing_level !== undefined) {
					const name = getName(this.agency_attach.packing_level, item.packing_level);
					if (name) selected.push(name);
				}

				if (item.add_packing && item.add_packing.length > 0) {
					item.add_packing.forEach(id => {
						const name = getName(this.agency_attach.add_packing, id);
						if (name) selected.push(name);
					});
				}

				if (item.template && item.template.length > 0) {
					item.template.forEach(id => {
						const name = getName(this.agency_attach.template, id);
						if (name) {
							const count = item[`template${id}_cnt`] || 1;
							selected.push(`${name}(${count}개)`);
						}
					});
				}

				if (item.customs && item.customs.length > 0) {
					item.customs.forEach(id => {
						const name = getName(this.agency_attach.customs, id);
						if (name) selected.push(name);
					});
				}

				return selected.join(', ');
			},
			openExtraServicesDialog(index) {
				this.currentExtraServiceItemIndex = index;
				this.extraServiceDialogVisible = true;
			},
			clearCurrentExtraItemServices() {
				if (this.currentExtraItem) {
					const item = this.currentExtraItem;
					item.remove = [];
					item.check_level = '';
					item.packing_level = '';
					item.add_packing = [];
					item.template = [];
					item.customs = [];
					if (this.agency_attach && this.agency_attach.template) {
						this.agency_attach.template.forEach(t => {
							this.$set(item, `template${t.id}_cnt`, 1);
						});
					}
					this.$message.success('선택한 부가서비스가 모두 초기화되었습니다.');
				}
			},
			/**
			 * 生成唯一ID，用于表单项的key
			 */
			generateId() {
			  return Date.now() + '_' + Math.random().toString(36).substr(2, 9)
			},
			
			/**
			 * 添加新的表单项
			 */
			addItem() {
			  this.formData.items.push({
				id: this.generateId(), // 唯一标识，用于key
				category_id:'',
				category_name:'',
				hs_code: '',
				goods_name: '',
				tracking_no:'',
				size:'',
				order_no:'',
				color:'',
				price:'',
				product_code:'',
				box_count:'',
				apply_quantity:'',
				refer_code:'',
				url:'',
				shipping_memo:'',
				// origin: false,
				// package:false,
				// check:false,
				goods_image:'',
				imageUrl:'',
				showPopover: false,
				show_extra_services: false,
				remove: [],
				check_level: '',
				packing_level: '',
				add_packing: [],
				template: [],
				template15_cnt: 1,
				template16_cnt: 1,
				template17_cnt: 1,
				template18_cnt: 1,
				template19_cnt: 1,
				template20_cnt: 1,
				template21_cnt: 1,
				customs: [],
			  })
			},
		
			/**
			 * 删除指定索引的表单项
			 * @param {Number} index - 要删除的表单项索引
			 */
			removeItem(index) {
			 //  this.$confirm('确定要删除这个表单项吗？', '提示', {
				// confirmButtonText: '确定',
				// cancelButtonText: '取消',
				// type: 'warning'
			 //  }).then(() => {
				this.formData.items.splice(index, 1)
				// this.$message.success('表单项已删除')
			 //  }).catch(() => {
				// // 取消删除
			 //  })
			},
		
			/**
			 * 提交表单
			 */
			submitForm() {
				this.$refs.dynamicForm.validate((valid, fields) => {
					if (valid) {
						this.formData.data.is_agree
						if(this.formData.data.is_agree){
							// 表单验证通过，准备提交数据
							const submitData = {
								items: [...this.formData.items]
							}
							console.log(submitData,"结果")
							console.log(this.formData.data,"结果2")
							console.log(this.totalAmount.toFixed(2),"结果2")
							
				
							
							if(!this.formData.data.address_id){
								alert("주소 필수")
								return
							}
					
							request.post('/member/Agency/editDgency',
								{
									"id": this.$route.query.id,
									"item":submitData,
									"data":this.formData.data,
									"total_amount":this.totalAmount.toFixed(2),
									//"agreement_yn":this.agreement_yn,
									"delivery_center_code":this.deliveryCenterCode,
									"customs_type":this.customsType,
									"agency_type":'1',//运输代理
								}
							).then(response => {
								console.log(response,"提交?????")			  
								if(response.code ==1){
									alert('Success！！！');
									//console.log('审核！');
									this.$router.replace('/orderBundle');

								}else{
									alert(response.msg)
									return
								}
									
							});
							
							
							
							
						}else{
							alert("주의사항에 동의해야 등록이 가능합니다.")
						}
			  
					} else {
						// 表单验证失败，提取具体的错误信息 this.$message.error('작성된 내용을 확인하십시오.');
						if (fields) {
							const firstErrorField = Object.keys(fields)[0];
							const errorMessage = fields[firstErrorField][0].message;
							
							// 解析字段名，例如 "items.0.goods_name"
							const match = firstErrorField.match(/items\.(\d+)\.(.+)/);
							if (match) {
								const index = parseInt(match[1]) + 1; // 转换为 1-based 第几个商品
								this.$message.error(`제${index}번째 상품의 오류: ${errorMessage}`);
							} else {
								this.$message.error(`작성된 내용을 확인하십시오: ${errorMessage}`);
							}
						} else {
							this.$message.error('작성된 내용을 확인하십시오.');
						}
						return false;
					}
				})
			},
			/**
			 * 重置表单
			 */
			// resetForm() {
			//   this.$refs.dynamicForm.resetFields()
			//   this.$message.info('表单已重置')
			// }
		}
	}
</script>

<style scoped>
	/* 上传 */
	.avatar-uploader >>> .el-upload {
	    border: 1px dashed #d9d9d9;
	    border-radius: 6px;
	    cursor: pointer;
	    position: relative;
	    overflow: hidden;
	}
	.avatar-uploader >>> .el-upload:hover {
	    border-color: #409EFF;
	}
	.avatar {
	    width: 100px;
	    height: 100px;
	    display: block;
		margin-bottom: 10px;
	}
	.config-title-wrap {
	    display: flex;
		justify-content: space-between;
	    align-items: center;
	    margin-bottom: 60px;
		padding:0 50px;
	}
	.config-title-wrap h3 {
	    border: none;
	    padding-bottom: 0;
		font-size: 36px;
		font-weight: bold;
		padding: 0 0 24px 20px;
		/* border-bottom: 1px solid #bcbcbc; */
		position: relative;
		margin: 0 0 30px;
	}
	.config-title-wrap h3:before {
	    content: '';
	    display: block;
	    width: 10px;
	    height: 48px;
	    background: #ffd04b;
	    position: absolute;
	    left: 0;
	    top: -4px;
	}
	.config-title-wrap p {
	    color: var(--frontground-color);
	    line-height: 30px;
	    margin: 0;
	}
	.config-title-wrap .get-order {
	    display: flex;
	    flex-direction: column;
	}
	.config-title-wrap .get-order .top {
	    display: flex;
	    gap: 10px;
	}
	.config-title-wrap .get-order ul {
	    list-style-type: none;
	    padding: 0;
	    display: flex;
	    flex-direction: column;
	    gap: 5px;
	}
	.config-title-wrap .get-order li {
	    background: #fff;
	    border: 1px solid var(--border-color);
	    border-radius: 10px;
	    color: rgba(0, 0, 0, 0.8);
	    font-weight: 500;
	    display: flex;
	    align-items: center;
	    justify-content: space-between;
	    padding: 0 14px;
	    width: 160px;
	    height: 46px;
	}
	.config-title-wrap .top a {
	    font-weight: bold;
	    background-color: #f75706;
	    color: #fff;
	    display: flex;
	    justify-content: center;
	    align-items: center;
	    height: 97px;
	    width: 167px;
	    border-radius: 14px;
	    border: none;
	    text-decoration: none;
	}
	.config-title-wrap .link-excel {
		margin-top: 10px;
	    font-weight: 600;
	    background-color: #fff;
	    color: #111;
	    text-decoration: none;
	    border: 1px solid var(--border-color);
	    border-radius: 44px;
	    display: flex;
	    align-items: center;
	    justify-content: center;
	    padding: 15px 0;
	    min-width: 337px;
	    width: 100%;
	}
	.event-common-click-dialog{
		cursor:pointer;
	}
	.scroller{
		height:460px; overflow-y: auto;margin-bottom: 60px;
	}
	
	/* 分类弹框 */
	.agency-category-customs{
		display: flex;
	}
	.agency-category-customs .type-general{
		background-color: #0055d4;
		width: 18px;
		height: 18px;
		border-radius: 6px;
		margin: 0 5px 0 15px;
	}
	.agency-category-customs .type-list{
		background-color: #c33;
		width: 18px;
		height: 18px;
		border-radius: 6px;
		margin: 0 5px 0 15px;
	}
	.help-block{
	    background-color: #d5e6fa;
	    color: #274780;
	    display: flex;
	    min-height: 40px;
		padding:5px 0;
	    border-radius: 12px;
	    align-items: center;
	    padding-left: 19px;
	    margin: 17px 0 20px;
	}
	.agreement-box{
		border: 1px solid var(--border-color);
	/* 	background: #F5F8FD; */
		padding: 15px;
		margin: 25px 0 5px;
		border-radius: 20px;
	}
	.height-fixed-box{
		/* background: #F5F8FD; */
		height: 400px;
		overflow-y: scroll;
		padding-right: 20px;
		font-size: 12px;
		color: #333;
	}
	.height-fixed-box ol {
	    margin: 0;
	    padding: 0;
	}
	.height-fixed-box .depth1 {
	    border: 1px solid #e5e5e5;
	    border-radius: 13px;
	    margin-bottom: 20px;
	}
	.height-fixed-box li {
	    margin: 0 0 30px 0;
	    padding: 0;
	    list-style: none;
	}
	.height-fixed-box li li {
	    display: inline-flex;
	    align-items: center;
	    margin: 0;
	    padding: 3px 5px;
	    width: 30%;
	    font-size: 13px;
	}
	.height-fixed-box li strong.namecolor-blue {
	    background-color: #0055d4;
	    border-top-left-radius: 8px;
	    border-top-right-radius: 8px;
	    padding: 9px 25px 6px;
	    font-size: 15px;
	    margin-bottom: 0;
	}
	.height-fixed-box li strong {
	    display: block;
	    background: #666;
	    color: #fff;
	    font-weight: 500;
	}
	.height-fixed-box .name{
		cursor: pointer;
	}
	.air-popup-content{
		padding: 0 10px;
	}
	.air-popup-content h2 {
		color:var(--navy-color);
	    font-size: 36px;
	    font-weight: bold;
	    text-align: center;
	    margin-top: 54px;
	    margin-bottom: 70px;
	}
	.air-popup-content .category-title{
		color: var(--main-color);
		font-size: 20px;
		font-weight: bold;
	}
	ul.dot-list {
	    margin: 0;
	    padding: 0;
	    list-style: none;
		margin-top: 16px;
		margin-bottom: 20px;
		padding-left: 7px;
	}
	ul.dot-list li {
	    color: #333;
	    font-size: 16px;
	    line-height: 28px;
		font-weight: 600;
	}
	ul.dot-list li a{
		font-weight: bold;
		text-decoration: none;
		color: #337ab7;
	}
/* 	ul.dot-list > li:before {
	    content: '';
	    display: block;
	    position: absolute;
	    top: 12px;
	    left: 0;
	    width: 6px;
	    height: 6px;
	    background: var(--main-color);
	    border-radius: 50%;
	} */
	.air-popup-content strong {
		color: #fe561d;
		text-align: center;
		display: block;
		font-size: 18px;
		margin-top: 49px;
	}
	.link-btn{
		margin-top: 10px;
		display: inline-flex;
		justify-content: center;
		align-items: center;
		border-radius: 19px;
		font-weight: 600;
		font-size: 12px;
		text-transform: uppercase;
		text-decoration: none !important;
		border: 1px solid var(--main-color);
		padding: 7px 17px;
		width:180px;
		transition: 0.25s;
		line-height: normal;
		cursor: pointer;
	}
	.link-btn.type-2{
		color: var(--main-color);
		background: #fff;
	}
	.air-popup-content p.popup-desc {
		padding-top: 20px;
	    font-size: 14px;
	    font-weight: 500;
	}
	.customs-real-price {
	    display: flex;
	    gap: 20px;
	    justify-content: space-between;
	    margin-bottom: 60px;
	    flex-wrap: wrap;
		color:var(--background-color)
	}
	.customs-real-price .box {
	    flex: 1;
	    background: #fff;
	    border: 1px solid var(--border-color);
	    border-radius: var(--border-radius);
	    padding: 20px;
	}
	.customs-real-price .box .title {
	    font-weight: bold;
	    margin-bottom: 30px;
		text-align: center;
	}
	.input-group {
	    position: relative;
	    display: flex;
		align-items: center;
	    border-collapse: separate;
	}
	.customs-real-price .box .input-group-addon{
		padding-left: 10px;
	}
	.customs-real-price .box.total .title {
	    height: 44px;
	    line-height: 44px;
	    border-bottom: 1px solid var(--border-color);
	    margin: 0;
	    text-align: center;
	}
	.customs-real-price .explain {
	    flex: 0 0 100%;
	    text-align: right;
	    line-height: 160%;
	    margin: 0;
		color:var(--frontground-color)
	}
	.customs-after-box {
	    display: flex;
	    justify-content: space-between;
	    align-items: center;
	    background: #fff;
		color: var(--background-color);
	    border: 1px solid var(--border-color);
	    border-radius: var(--border-radius);
	    height: 147px;
	    padding: 40px;
	    margin-bottom: 30px;
	}
	.customs-after-box .customs strong {
	    font-size: 36px;
	    vertical-align: middle;
	}
	.customs-after-box .customs a {
	    border-radius: 12px;
	    text-decoration: none;
	    font-size: 17px;
	    width: 140px;
	    height: 55px;
	    line-height: 55px;
	    margin-left: 20px;
	    padding: 0;
	}
	.btn {
	    display: inline-block;
	    margin-bottom: 0;
	    font-weight: 400;
	    text-align: center;
	    white-space: nowrap;
	    vertical-align: middle;
	    touch-action: manipulation;
	    cursor: pointer;
	    background-image: none;
	    border: 1px solid transparent;
	}
	.btn-submit, .btn-submit:focus {
	    background-color: var(--main-color);
	    border-color: var(--main-color);
	    color: #fff !important;
	}
	.customs-after-box .after {
	    text-align: right;
	}
	.customs-after-box .after .total-price {
	    font-size: 24px;
	    font-weight: bold;
	}
	.customs-after-box .after .total-price span {
	    color: var(--main-color);
	}
	.type-card {
	    margin-bottom: 50px;
	    overflow: visible;
	}
	.type-card.shadow-all {
	    border: none;
		border-radius: 26px;
	    box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.1);
	}
	.type-card .card-head {
	    height: 77px;
	    text-align: left;
	    justify-content: left;
	    font-size: 24px;
	    padding-left: 40px;
	    font-weight: bold;
	    border-top-left-radius: 26px;
	    border-top-right-radius: 26px;
	}
	.type-card > .card-head {
	    line-height: normal;
	    display: flex;
	    align-items: center;
	    color: #fff;
	    gap: 0 8px;
	    background: var(--secondary-color);
	}
	.type-card .card-body {
	    padding: 35px 39px;
	    border-bottom-left-radius: 26px;
	    border-bottom-right-radius: 26px;
		background-color: var(--frontground-color);
	}
	.link-btn.type-1 {
	    color: #fff;
	    background: var(--main-color);
	}
	.type-card .card-help {
	    font-size: 17px;
	    font-weight: 600;
	    color: var(--navy-color);
	    background: #f4f8ff;
	    padding: 12px 20px;
	    margin-bottom: 30px;
	}
	.checkbox-inline{
		display: flex;
		align-items: center;
		border: 1px solid var(--border-color);
		border-radius: 14px;
		padding: 13px 10px !important;
		font-size: 15px;
		font-weight: bold;
/* 		width: 100%; */
		height: 50px;
		background-color: #fff;
		margin: 15px 20px 15px 0;
	}
	
	.checkbox-inline-margin{
		margin: 15px 30px 0 0
	}
	
	label.checkbox-inline > span {
	    margin-left: auto;
	    color: var(--main-color);
	    font-size: 14px;
	    font-weight: 500;
	}
	.col-wrap h4{
		font-size: 20px;
		font-weight: bold;
		color: var(--background-color);
		/* margin: 0 0 15px; */
	}
	.col-wrap .group{
		margin-bottom: 30px;
	}
	.card-help .normal {
	    font-weight: normal;
	    display: block;
	    font-size: 16px;
	}
	.caution-box {
	    border-radius: var(--border-radius);
	    /* background: #f5f6fb; */
	    margin-bottom: 30px;
		padding:20px;
		line-height: 30px;
		font-size: 14px;
	}
	.caution-agree {
	    border: 1px solid var(--border-color);
	    text-align: center;
	    padding: 20px 0 21px;
	    margin-bottom: 30px;
	}
	/* 注册录入商品 */
	.section-header {
	    position: relative;
	    border-bottom: 1px solid #e0e0e0;
	    margin-bottom: 20px;
	}
	.section-header h1 {
	    font-size: 22px;
	    font-weight: bold;
	    letter-spacing: -0.01em;
	    margin-top: 0px;
		margin-bottom: 40px;
	    text-align: left;
	}
	.section-header h1 span {
	    color: #ff5700;
	}
	.section-header p {
	    font-size: 14px;
	    line-height: 20px;
	    letter-spacing: -0.01em;
	    margin-bottom: 27px;
	}
	.section-header a {
	    display: inline-flex;
	    align-items: center;
	    justify-content: center;
	    height: 49px;
	    width: 190px;
	    gap: 6px;
	    background: #fff;
	    font-size: 15px;
	    letter-spacing: -0.01em;
	    color: #333;
	    border: 1px solid #808080;
	    text-decoration: none;
	    position: absolute;
	    top: 2px;
	    right: 0;
	    border-radius: 44px;
	}
	


	
	.icon-question{
		color:var(--main-color);padding-left: 5px;font-size: 18px;
	}
	.flex{
		display: flex;
	}
	.color-blue {
	    color: #0055d4 !important;
	}
	.color-red {
	    color: #cc3333 !important;
	}
	.text-center {
	    text-align: center !important;
	}
	.font-popover{
		font-size: 12px;font-weight: 400;
	}
	.el-table::before {
	    background-color: rgba(255,255,255,0) ;
	}
	.background-color{
		color:var(--background-color);
	}
	.frontground-color{
		color: var(--frontground-color);
	}

	/* 分类虚拟下拉样式 */
	.category-popper {
		max-width: 100vw;
		padding: 0 !important;
	}
	.category-dropdown-content {
		padding: 15px;
		background: #fff;
	}
	.category-dropdown-content .search-box {
		margin-bottom: 12px;
	}
	.scroller-container {
		border: 1px solid #eee;
		border-radius: 8px;
		overflow: hidden;
		display: flex;
		flex-direction: column;
		height: 400px; /* 下拉高度稍微调小一点 */
	}
	.v-table-header {
		display: flex;
		background-color: #f0f7ff;
		height: 40px;
		align-items: center;
		padding: 0 15px;
		font-weight: bold;
		color: #0055d4;
		font-size: 13px;
		border-bottom: 1px solid #d0e3f7;
	}
	.category-v-scroller {
		flex: 1;
	}
	.v-category-row {
		display: flex;
		align-items: center;
		padding: 0 15px;
		height: 65px;
		border-bottom: 1px solid #f5f5f5;
		box-sizing: border-box;
	}
	.v-category-row:hover {
		background-color: #fafafa;
	}
	.v-col-l1 { width: 120px; flex-shrink: 0; color: #0055d4; font-weight: bold; font-size: 13px; }
	.v-col-l2 { width: 220px; flex-shrink: 0; padding: 0 10px; display: flex; flex-direction: column; justify-content: center; }
	.v-col-l3 { flex: 1; min-width: 0; padding-left: 10px; display: flex; flex-direction: column; justify-content: center; }
	
	.v-category-row .ko { font-size: 13px; color: #333; margin-bottom: 2px; }
	.v-category-row .cn { font-size: 11px; color: #e67e22; font-weight: 500; }
	.v-category-row .code { color: #999; font-family: monospace; font-size: 11px; }

	::v-deep .hl-text-category {
		background-color: #fffb8f;
		color: #f5222d;
		font-weight: bold;
		padding: 0 2px;
		border-radius: 2px;
	}

	@media (min-width: 992px) {
		.content-zsy{
			width: 1270px;
			margin: 2.5rem auto;
		}
	}
	@media (max-width: 768px) {
		.content-zsy{
			padding:40px 10px;
		}
		.config-title-wrap{
			padding:0 10px;
		}
		.config-title-wrap h3 {
		    font-size: 24px;
		    font-weight: bold;
		    padding: 0 0 14px 12px;
		    position: relative;
		    margin: 0 0 20px;
		}
		.config-title-wrap h3:before {	
		    width: 4px;
		    height: 21px;
		    top: 6px;
		}
		.air-popup-content h2 {
			font-size: 24px;
			margin-top: 14px;
			margin-bottom: 30px;
		}
		.air-popup-content strong {
			display: block;
			font-size: 16px;
			margin-top: 10px;
		}
		.customs-real-price {
		    gap: 15px;
		}
		.customs-real-price .box{
			padding: 10px;
		}
		.customs-real-price .box .title {
		    font-size: 14px;
		}
		.customs-after-box {
		    display: flex;
		    justify-content: space-between;
		    align-items: center;
		    background: #fff;
		    border: 1px solid var(--border-color);
		    border-radius: var(--border-radius);
		    padding: 20px;
		    margin-bottom: 40px;
		    flex-wrap: wrap;
		}
		.customs-after-box .customs {	
		    display: flex;
		    justify-content: space-between;
		    align-items: center;
		    width: 100%;
		    padding-bottom: 10px;
		    border-bottom: 1px solid var(--border-color);
		    margin-bottom: 10px;
		}
		.customs-after-box .customs a {
		    width: 75px;
		    height: 36px;
		    line-height: 36px;
		    background-color: var(--secondary-color) !important;
		}
		.customs-after-box .customs strong {
		    font-size: 18px;
		}
		.customs-after-box .after{
			text-align: right;
			 width: 100%;
		}
		.customs-after-box .after .total-price {
		    font-size: 18px;
		}
		.type-card .card-body {
		    padding: 20px;
		    background: #fff;
		}
		.type-card .card-help {
		    padding: 10px;
			font-size: 14px;
		    margin-bottom: 20px;
		    word-break: keep-all;
		    line-height: 160%;
		}
		

		
	}

	::v-deep .num-input-left .el-input__inner {
		text-align: left !important;
		padding-left: 15px;
	}

</style>